export const en = {
  errorBoundary: {
    title: "An unexpected error occured.",
    body:
      "We have recorded the error and apologize for the inconvenience. Please try again.",
    button: "Return to Home Page",
    sandbox: {
      title: "SANDBOX: An unexpected error has occured.",
      body:
        "Sandbox mode has encountered an unexpected error, please reset or disable Sandbox mode.",
      resetButton: "Reset Sandbox",
      disableButton: "Disable Sandbox"
    }
  },
  profile: {
    minorityStatusList: {
      added: "Added certification",
      errorAdded: "Error adding certification",
      saved: "Certifications Saved",
      errorSaved: "Error when saving certifications. Try again later.",
      updated: "Certifications Updated",
      errorUpdated: "Error when updating certifications. Try again later.",
      deleted: "Certifications Deleted",
      errorDeleted: "Error when deleting certifications. Try again later.",
      loading: "Loading...",
      noMinorityStatusHelpText: {
        title: "No Certifications",
        body:
          "Certifications added to a profile can be used to include minority information about your company."
      },
      noMinorityStatusButtonText: "Add Certification",
      deleteConfirmation: "Are you sure you want to delete?",
      minorityStatus: {
        updated: "Updated minority status",
        errorUpdated: "Error updating minority status",
        deleted: "Deleted minority status",
        errorDeleted: "Error deleting minority status"
      }
    },
    mainDetails: {
      updated: "Profile updated successfully.",
      errorUpdated: "Error updating profile."
    },
    logo: {
      updated: "Image uploaded successfully",
      errorUpdated: "Error uploading image",
      exceedSizeError: "Image size can not exceed 2MB",
      imageTypeError: "Supported image formats are .bmp, .jpeg, and .png."
    }
  },
  contactManagement: {
    addCompanyModal: {
      title: 'Add Company',
      companyCode: 'Company Code',
      companyName: 'Company Name',
      cancel: 'Cancel',
      save: 'Save',
      saveAnd: 'Save and',
      edit: 'Edit'
    },
    contactSearchButton: {
      name: "Contacts"
    },
    contactSearchModal: {
      noData: {
        title: "No results found",
        body:
          "Try searching for a contact by first name, last name, phone or email. You can also search by company name and code."
      },
      tabs: {
        contacts: "CONTACTS",
        companies: "COMPANIES"
      },
      searchBarPlaceholder: "Search for contacts..."
    },
    vendorDetails: {
      title: "Main Details",
      newTitle: "Create New Company",
      editTitle: "Edit Details",
      save: "Save",
      edit: "Edit",
      minorityStatusesHeading: "Minority Statuses",
      scopesHeading: "Scopes",
      notesHeading: "Notes",
      officeHeading: "Office",
      accountingCodeHeading: "Accounting Code",
      isBonded: "Is Bonded",
      bondRate: "Bond Rate (%)",
      HBAlternateOffice: "(Alternate from HeavyBid)",
      HBPrimaryOffice: "(Primary from HeavyBid)"
    },
    vendorEditDetail: {
      addOfficeButton: "Add new office",
      officeSectionTitle: "Offices",
      error: {
        title: "Error Saving Company",
        name: "Office Nickname is required"
      }
    },
    vendorLocationDetails: {
      nickname: "Nickname"
    },
    vendorList: {
      title: "Company List",
      addCompany: "Add Company",
      searchPlaceholder: "Search Companies..."
    },

    contactFields: {
      firstName: "First Name",
      lastName: "Last Name",
      title: "Title",
      email: "Email Address",
      phone: "Phone Number",
      cell: "Cell Number",
      mainContact: "Main Contact",
      notes: "Notes"
    },
    contactList: {
      saved: "Contact Added!",
      errorSaved: "Error when saving contact. Try again later.",
      errorMoved: "Error when moving contact. Try again later.",
      moveContact: "Contact Moved!",
      updated: "Contact Saved!",
      errorUpdated: "Error when updating contact. Try again later.",
      deleted: "Contact Removed!",
      errorDeleted: "Error when deleting contact. Try again later.",
      emailError: "Please enter a valid email address.",
      title: "Contacts List",
      loading: "Loading...",
      noContactsHelpText: {
        title: "No Contacts",
        body: "Contacts added to a Company can be linked to a Project"
      },
      noContactsButtonText: "Add Contact",
      deleteConfirmation: "Are you sure you want to delete {0}?",
      commandButton: {
        name: "Manage",
        edit: "Edit",
        move: "Move",
        delete: "Delete"
      },
      visitContact: "Visit Contact",
      searchPlaceholder: "Search Contacts..."
    },
    contactListModal: {
      modalAddTitle: "Add Contact",
      modalEditTitle: "Edit Contact",
      buttonAdd: "Add",
      buttonSave: "Save",
      buttonCancel: "Cancel",
      emptyLocationsText: "Please edit Company details to add an Office",
      emptyScopeOfWorksText:
        "Please edit Company details to add Scopes of Work",
      officeLabel: "Office",
      scopesLabel: "Scopes",
      placeholders: {
        firstName: "First Name",
        lastName: "Last Name",
        title: "Title",
        email: "Email",
        cell: "Cell Number",
        phone: "Phone Number",
        notes: "Notes",
        mainContact: "Main Contact",
        office: "Office",
      }
    },
    contactListMoveContactModal: {
      moveContact: "Move",
      toCompany: "To Company:",
      fromCompany: "From Company:",
      buttonMove: "Move",
      buttonCancel: "Cancel",
      removingProductsAlert:
        "The following scopes will be removed from the contact because the destination company does not have these scopes set:",
      removingOneProductAlert:
        "The following scopes will be removed from the contact because the destination company does not have the scope set:"
    },
    minorityStatusList: {
      saved: "Minority Status Saved",
      errorSaved: "Error when saving minority status. Try again later.",
      updated: "Minority Status Updated",
      errorUpdated: "Error when updating minority status. Try again later.",
      deleted: "Minority Status Deleted",
      errorDeleted: "Error when deleting minority status. Try again later.",
      loading: "Loading...",
      noMinorityStatusHelpText: {
        title: "No Minority Status",
        body:
          "Minority statuses added to a company can be used to track minority goals on projects and estimates."
      },
      noMinorityStatusButtonText: "Add Minority Status",
      deleteConfirmation: "Are you sure you want to delete?"
    },
    minorityTypeModal: {
      columnsName: {
        code: "Code",
        description: "Description"
      },
      title: "Create Minority Type",
      buttonAdd: "Add",
      buttonCancel: "Cancel",
      validation: {
        codeRequiredText: "Code is required",
        descriptionRequiredText: "Description is required"
      },
      errorUpdated: "Error updating minority type. Try again later.",
      errorCreated: "Error creating minority type. Try again later.",
      confirmBack:
        "You have unsaved changes. Are you sure you want to continue?"
    },
    scopeOfWorkModal: {
      columnsName: {
        code: "Code",
        description: "Description"
      },
      confirmBack:
        "You have unsaved changes. Are you sure you want to continue?"
    },
    notInBU: `The company you tried to access is not in your current Business Unit.`,
    noDataPlaceholder: {
      office: {
        title: "No Offices",
        buttonText: "Add new office"
      },
      minorityStatus: {
        title: "No Minority Statuses",
        body:
          "To add a Minority Status to this company, first hit 'Save' on the new vendor with the 'Code' field filled out"
      }
    },
    companySetup: {
      title: "Company Setup",
      minorityTypeHeader: "Minority Types",
      minorityType: {
        success: {
          added: "Minority Type Added!",
          updated: "Minority Type Saved!"
        },
        errors: {
          created: "Error creating product type. Try again later.",
          updated: "Error updating product type. Try again later.",
          deleted: "Error deleting product type. Try again later.",
          duplicated: "Minority type with code '{0}' already exists."
        }
      },
      productType: {
        header: "Scopes of Work",
        success: {
          added: "Scope of Work Added!",
          updated: "Scope of Work Saved!"
        },
        errors: {
          created: "Error creating product type. Try again later.",
          updated: "Error updating product type. Try again later.",
          deleted: "Error deleting product type. Try again later.",
          duplicated: "Scope of work with code '{0}' already exists."
        }
      }
    },
    import: {
      placeholder: "Please drop your file here or click to select",
      selectedFile: "Selected File",
      sheetSelector: "Sheet Selector",
      settings: {
        defaultCompanyCode: {
          label: "Default Company Code",
          options: {
            fullName: "Full Company Name",
            first12: "First 12 characters of Company Name"
          }
        },
        companyExist: {
          label: "If a company record in the sheet already exists?",
          options: {
            skip: "Skip",
            overwrite: "Overwrite",
          }
        },
        contactExist: {
          label: "If a contact record in the sheet already exists?",
          options: {
            skip: "Skip",
            overwrite: "Overwrite",
          }
        },

      },
      acceptedFiles: "Accepted file formats: .xls, .xlsx, .csv.",
      rowLimit: "Limit to 1000 rows.",
      validationErrors: {
        name: "Company Name is required. This row will be skipped.",
        nickname: "Office Nickname is required when mapping address fields. This row will be skipped.",
        email: "Row #{0} has a bad email address, if not fixed, it will not be imported."
      },
      importMapping: {
        requiredField: "Required for new and existing records.",
        requiredForNewRecords: "Required for new records.",
        requiredForExistRecords: "Required for existing records.",
        requiredNicknameField: "Required when mapping address fields.",
        booleanAcceptableValues: "Acceptable values: Y/N, Yes/No, True/False, T/F, 1/0",
        contactMethodAcceptableValues: "Acceptable values: Email, Phone"
      },
      prevalidation: {
        error: "Error",
        title: "Pre-Import Contact Validations",
        copyBtn: "Copy",
        row: "Row",
        message: "Message",
        rowLimitError: "Contact imports are limited to 1000 rows at a time. Please upload a file with 1000 rows or less and try again.",
      },
      importResult: {
        importingLabel: "Importing...",
        completeLabel: "Import Complete!",
        validationsTitle: "Contact Validations",
        companiesCreated: "Companies created:",
        companiesUpdated: "Companies updated:",
        contactsCreated: "Contacts created:",
        contactsUpdated: "Contacts updated:"
      }
    }
  },
  estimates: {
    active: "Active",
    archived: "Archived",
    recent: "Recent",
    synced: "Synced",
    title: "Estimates",
    editTitle: "Edit Archived Estimates",
    estimateAnalysis: "Estimate Analysis",
    keyIndicators: "Key Indicators",
    estimateDetails: "Estimate Details",
    estimateInformation: "Estimate Information",
    estimateLocation: "Estimate Location",
    estimateExcluded: "Exclude Estimate",
    quoteManagement: "Quote Management",
    quoteSummary: "Quote Summary",
    dashboard: "Dashboard",
    solicitationDashboard: "Solicitation Dashboard",
    quoteInbox: "Quote Inbox",
    createSolicitation: "Create Solicitation",
    createQuoteProposal: "Create Quote Proposal",
    drafts: "Drafts",
    sent: "Sent",
    vendorCommunication: "Vendor Communication",
    noReports: "Reports are not yet available for this estimate",
    noEstimatesTitle: "We couldn't find any solicitations for this Estimate",
    noEstimatesHelperText: `Select Create Solicitation in the left menu to start populating\nthis Quote Management dashboard`,
    reporting: "Reporting",
    allReports: {
      unavailable: {
        title: "No Reports Available",
        text:
          "The estimate is currently syncing, reports will be ready upon completion."
      },
      notFound: {
        title: "No Reports Found",
        text:
          "No reports could not be found for the current estimate. Try re-syncing this estimate."
      }
    },
    reportDownload: "Download the PDF",
    cost: "Cost",
    costDescription:
      "The Cost report shows the costs for each biditem broken down by activity and cost type.",
    costAndPrice: "Cost and Price",
    costAndPriceDescription:
      "A summary report displaying a complete cost and price breakdown for each biditem.",
    estimateRecap: "Estimate Recap",
    estimateRecapDescription:
      "The Estimate Recap report shows you how bid/takeoff differences and bid price unbalancing affect the estimate. It also allows you to review cost totals and percentages for each cost type.",
    reportsHelpText: "Reports are current as of",
    showAll: "Show All",
    hideAll: "Hide All",
    close: "Close",
    showHideColumns: "Show/Hide Columns",
    adjustFilters: "Adjust Filters",
    addFilters: "Add Filters",
    selectFilters: "Select Filters",
    activeEstimates: "Active Estimates",
    activeEstimateTotal: "Active Estimate Total",
    archivedEstimates: "Archived Estimates",
    archivedEstimateTotal: "Avg Archived Estimate",
    activeEstimateLocations: "Active Estimate Locations",
    noLocationFound: "No Location Found",
    codebooks: {
      title: "Codebooks Dashboard",
      reportTitle: "Report:",
      division: "HeavyBid Division:",
      lastUpdateCodebook: "Codebook data last uploaded:",
      lastUpdateEstimate: "Estimate data last uploaded:",
      datePicker: {
        title: "Include Estimates From:",
        placeholder: "Select a date range...",
        last3Months: "Last 3 months",
        last6Months: "Last 6 months",
        lastYear: "Last 12 months",
        custom: "Custom"
      },
      unused: {
        subtitle: "Unused",
        text: "Activity Codebook Codes that have not been used in an estimate",
        pageTitle: "Unused Activity Codebook Codes",
        noUnusedCodes: "There are no unused Activity Codebook Codes in the Activity Codebook",
        noMatchingFilters: "No Activity Codebook Codes are available with the current filters"
      },
      utilized: {
        subtitle: "Utilized",
        text: "Activity Codebook Codes used or modified in an estimate",
        pageTitle: "Activity Codebook Codes Used in an Estimate",
        tip: "Click a row to view details",
        pageTitle2: "Modifications to Activity Code",
        noUtilized: "No Activity Codebook Codes have been utilized",
        noMatchingFilters: "No Activity Codebook Codes are available with the current filters",
        noModifications: "No modifications have been made",
        noMatchingSearch: "No Activities are available with the current filters"
      },
      missing: {
        subtitle: "Missing",
        text: "Activity Codes that are missing from the Activity Codebook",
        pageTitle: "Activities missing from the Activity Codebook",
        noMissingActivities: "There are no Activities missing from the Activity Codebook",
        noMatchingFilters: "No Activities are available with the current filters"
      },
      columnNames: {
        activityCode: "Activity Code",
        codebookCode: "Codebook Code",
        description: "Description",
        unit: "Unit",
        level: "Level",
        estimateCode: "Estimate",
        biditemCode: "Biditem",
        activityCodebookCode: "Codebook Code",
        lastUpdate: "Last Updated",
        lastModified: "Last Modified"
      },
      schema: {
        name: "Activity Codebooks",
        codebookCode: "Codebook Code",
        codebookDescription: "Description",
        codebookUnits: "Unit",
        codebookLevel: "Level",
        codebookModifiedCount: "Times Modified",
        codebookPartitionId: "Partition Id",
        codebookLastUpdate: "Last Updated",
        codebookTimesUsed: "Times Used",
        codebookTimesModified: "Times Modified",
        activityCode: "Activity Code",
        activityDescription: "Activity Description",
        activityUnits: "Activity Units",
        activityLastModified: "Last Modified",
        activityPartitionId: "Partition Id",
        biditem: "Biditem Code",
        estimate: "Estimate Code",
      },
      iconAlt: "Codebooks",
      reportOverflow: "Maximum number of records reached. Please narrow date range to include all results.",
    },
    noLocationFoundHelpText:
      "Either your estimate has no location information, or we were unable to obtain latitude and longitude with the information provided.",
    gettingStarted: {
      title: "Accessing Estimating Data",
      text1:
        "To access estimating data, it is now required that you have the 'HeavyBid Insights' subscription in HCSS Credentials. Steps to get started can be accessed in the HCSS Help Center.",
      instructions:
        "You don't have permission to view Estimate Insights. This can be configured by an admin in the User Admin page.",
      buttonIconTitle: "Get Started Now"
    },
    notInBU: `The estimate you tried to access is not in your current Business Unit.`,
    customizeReporting: {
      customizeActivityTotals: "Customize Activity Totals",
      save: "Save",
      activityTotals: "Activity Totals",
      placeholder: {
        button: "Add a total",
        title: "Add Activity Totals",
        body:
          "This page will allow you to add a custom Activity Total formula. By specifying an expression, unit, and matching style, you will be able to see the Quantity and Cost totals for Activity codes that match what you enter across all of your synced and archived HeavyBid estimates."
      },
      name: "Name",
      nameRequired: "Name is required",
      expression: "Expression",
      expressionRequired: "Expression is required",
      unit: "Unit",
      unitRequired: "Unit is required",
      formulaMatch: {
        startsWith: "Starts with",
        exactlyMatches: "Exactly matches"
      }
    },
    estimateTypeSelectorOptions: {
      synced: "Synced Estimates",
      archived: "Archived Estimates",
      all: "All Estimates"
    }
  },
  keyIndicators: {
    placeholder: "Search KPIs",
    settings: "Settings",
    kpiDisplay: "Display KPIs marked as",
    classification: "Classification",
    search: "Search",
    normal: "Normal",
    warning: "Warning",
    outlier: "Outlier",
    na: "N/A",
    allKpis: "Total KPIs",
    kpisByCategory: "KPIs by Category",
    help: "Help",
    noCustomBody: "Sync your custom KPIs from HeavyBid to see them here.",
    breakdownModal: {
      title: "Source Data",
      close: "Close",
    },
    table: {
      currentValue: "Current Value",
      normalRange: "Normal Range",
      plot: "Plot",
      name: "Name",
      calculationDetails: "Calculation Details",
      noVariance: "Unable to chart. No variance in normal range.",
      noData: "There are no KPIs to display with the current filters.",
      allKpisHidden:
        "There are no KPIs selected. Please select one or more KPIs to display KPI data."
    },
    categories: {
      labor: "Labor",
      equipment: "Equipment",
      material: "Material",
      subcontract: "Subcontract",
      markup: "Markup",
      other: "Other",
      custom: "Custom",
      laborAndEquipment: "Labor and Equipment"
    },
    estimate: "1 Estimate used for KPI Analysis",
    estimates: "{0} Estimates used for KPI Analysis"
  },
  vendorCommunication: {
    columns: {
      vendorCode: "Vendor Code",
      vendorName: "Vendor Name",
      action: "Last Activity",
      timeStamp: "Date of Last Activity",
      minorityType: "Minority Type",
      email: "Contact",
      solicitationName: "Solicitation Name",
      projectName: "Project Name"
    },
    manualModal: {
      phoneCallMade: "Made Phone Call",
      phoneCallReceived: "Received Phone Call",
      emailSent: "Sent Email",
      emailReceived: "Received Email",
      faxSent: "Sent Fax",
      faxReceived: "Received Fax",
      mailSent: "Sent Mail",
      mailReceived: "Received Mail",
      inPerson: "In Person Meeting",
      communicationSuccess: "Communication recorded successfully",
      communicationError: "Unable to record communication",
      title: "Record Communication",
      type: "Communication Type",
      date: "Date of Communication",
      vendor: "Vendor",
      estimate: "Estimate",
      projectName: "Project Name",
      contactInfo: "Contact Information",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      message: "Message",
      cancel: "Cancel",
      submit: "Submit",
      previewReport: "Preview Report"
    },
    details: {
      recordCommunication: "Record Communication",
      print: "Print",
      vendor: "Vendor",
      project: "Project",
      minorityType: "Minority Type",
      communicationDetails: "Communication Details"
    },
    timeline: {
      eventHistory: "Event History",
      filters: "Filters",
      filterContent: "Filter Content",
      clickToExpand: "Click to expand...",
      initial: "an initial solicitation",
      followUp: "a followup solicitation",
      addendum: "an addendum",
      noName: "no name",
      solicitation: {
        initial: {
          base: "{0} {1} sent {2} {3} from {4} an initial solicitation ({5}).",
          special:
            "{0} {1} sent {2} {3} from {4} an initial solicitation (no name)."
        },
        followUp: {
          base: "{0} {1} sent {2} {3} from {4} a follow-up solicitation ({5}).",
          special:
            "{0} {1} sent {2} {3} from {4} a follow-up solicitation (no name)."
        },
        addendum: {
          base: "{0} {1} sent {2} {3} from {4} an addendum ({5}).",
          special: "{0} {1} sent {2} {3} from {4} an addendum (no name)."
        }
      },
      sub: {
        accepted: "{0} has indicated they will be bidding on this project",
        rejected: "{0} has indicated they will not be bidding on this project",
        submittedPrices: "{0} submitted a quote for {1}"
      },
      gc: {
        reviewed: "{0} {1} reviewed a quote for {2}",
        markedAsUnread: "{0} {1} has marked a quote as unread",
        rejected: "{0} {1} rejected a quote for {2}",
        manuallyRejected:
          "{0} {1} chose to manually enter these quote prices directly into HeavyBid.",
        queuedForSync: "{0} {1} queued a quote for {2} to sync with HeavyBid."
      },
      manual: {
        phoneCall: {
          sent: "{0} {1} made a phone call to {2} {3}",
          received: "{0} {1} received a phone call from {2} {3}"
        },
        email: {
          sent: {
            base: "{0} {1} sent an email to {2} {3} ({4})",
            special: "{0} {1} sent an email to {2} {3} (no email provided)"
          },
          received: {
            base: "{0} {1} received an email from {2} {3} ({4})",
            special:
              "{0} {1} received an email from {2} {3} (no email provided)"
          }
        },
        fax: {
          sent: "{0} {1} sent a fax to {2} {3}",
          received: "{0} {1} received a fax from {2} {3}"
        },
        mail: {
          sent: "{0} {1} sent mail to {2} {3}",
          received: "{0} {1} received mail from {2} {3}"
        },
        meeting: "{0} {1} met in person with {2} {3}",
        gcEnteredPricesForSub:
          "{0} {1} entered prices on behalf of the subcontractor"
      },
      unknownAction: "Unknown event action",
      will: "will",
      willNot: "will not"
    },
    report: {
      vendor: "Vendor:",
      bidding: "Bidding?:",
      yes: "Yes",
      no: "No",
      unknown: "Unknown",
      minority: "Minority:",
      action: "Action",
      actions: {
        sentInitialSolicitation: "Sent initial solicitation invite",
        sentFollowUpSolicitation: "Sent follow-up solicitation invite",
        sentAddendumSolicitation: "Sent addendum solicitation invite",
        subAcceptedInvite: "Subcontractor accepted invitation",
        subRejectedInvite: "Subcontractor rejected invitation",
        subSubmittedPrices: "Subcontractor submitted prices",
        gcRejectedPrices: "General contractor rejected prices",
        gcReviewedPrices: "General contractor reviewed prices",
        madePhoneCall: "Made phone call",
        receivedPhoneCall: "Received phone call",
        sentEmail: "Sent email",
        receivedEmail: "Received email",
        sentFax: "Sent fax",
        receivedFax: "Received fax",
        sentMail: "Sent mail",
        receivedMail: "Received mail",
        inPersonMeeting: "Met in person",
        gcEnteredPricesForSub:
          "General contractor entered prices on behalf of subcontractor",
        gcReconsideredPrices:
          "General contractor marked rejected quote as Unread",
        gcReconsideredManuallyEnteredPrices:
          "General contractor marked manually entered quote as Unread",
        gcManuallyEnteredPrices:
          "General Contractor manually entered quote prices into HeavyBid",
        gcQueuedForSync: "General Contractor queued quote for sync to HeavyBid",
        default: "Last communicated"
      },
      description: "Description/Message",
      dateTime: "Date/Time",
      vendorContact: "Vendor Contact",
      user: "User",
      code: "Estimate Code:",
      linkedEstimate: "Linked Estimate:",
      name: "Estimate Name:",
      owner: "Owner:",
      bidDate: "Bid Date:",
      title: "Communication Report",
      vendorComTitle: "Vendor Communication Report",
      preview: "Communication Report - Preview",
      vendorPreview: "Vendor Communication Report - Preview",
      back: "Back"
    }
  },
  isRequired: "{0} is required.",
  estimateInfo: {
    state: "State:",
    lastSync: "Last Sync:",
    keyDates: "Key Dates:",
    reviewDate: "Review Date:",
    bidDate: "Bid Date:",
    startDate: "Start Date:",
    totals: "Totals",
    totalCost: "Total Cost:",
    bidTotal: "Bid Total:",
    title: "Estimate Information",
    lastSummaryRunOn: "Last Summary Run On:",
    lastSpreadRunOn: "Last Spread Run On:"
  },
  estimateTable: {
    linkEstimates: "Link Estimates",
    noLinkedEstimates: "No Linked Estimates to display"
  },
  estimateModal: {
    title: "Link Estimates",
    activeEstimates: "Active Estimates",
    errorLoading:
      "There was a problem loading your estimates. Please refresh the page.",
    loading:
      "Estimates are currently loading. This may take a few minutes the first time.",
    columns: {
      code: "Estimate Code",
      name: "Estimate Name",
      bidDate: "Bid Date",
      lastModified: "Last Updated",
      isActiveEstimate: "Active Estimate"
    }
  },
  quoteProposal: {
    notifications: {
      drafts: {
        success: "Successfully deleted draft",
        error: "Unable to delete draft"
      }
    },
    deleteConfirmationName: "Are you sure you want to delete {0}?",
    deleteConfirmationNoName: "Are you sure you want to delete (no name)?",
    draftQuotes: "Draft Quotes",
    sentQuotes: "Sent Quotes",
    columns: {
      name: "Name",
      createdDate: "Date Created",
      dueDate: "Date Due",
      vendors: "Vendors",
      type: "Type",
      code: "Code",
      description: "Description",
      email: "Email",
      minorityType: "Minority Type",
      url: "URL",
      estimator: "Estimator",
      vendorCode: "Vendor Code",
      vendorName: "Vendor Name",
      lastName: "Last Name",
      firstName: "First Name",
      phoneNumber: "Phone Number"
    },
    links: {
      noDataText: "Add External Links"
    },
    contacts: {
      removeContact: "Remove Contact",
      chooseContact: "Choose Contact",
      addContact: "Add Contact"
    },
    preview: {
      notifications: {
        emailError: "Error sending emails. Please try again."
      },
      personalEmail: "Personal email account",
      viaBusinessUnitEmail: "via business unit email account",
      viaOtherEmail: "via <{0}>",
      loading: "Loading...",
      sendingEmail: "Sending email...",
      useCompanyEmail: "Use your company personal email account",
      personalEmailNeedsAttention:
        "Your personal email account needs attention",
      sendPreview: "Send Proposal Preview",
      cancel: "Cancel",
      sendAll: "Send All",
      sendingFrom: "Sending From",
      sendingTo: "Sending To",
      emailSubject: "Email Subject",
      emailSubjectRequired: "Email subject is required.",
      emailPreview: "Email Preview",
      proposalPreview: "Proposal Preview",
      loadingPreview: "Loading Preview...",
      quoteProposalFor: `Quote Proposal for "{0}"`,
      quoteProposal: "Quote Proposal"
    },
    projectDetails: {
      code: "Project Code",
      codeRequired: "Project code is required.",
      name: "Project Name",
      nameRequired: "Project Name is required.",
      location: "Project Location"
    },
    setup: {
      emailsSentSuccessfully: "Successfully sent emails!",
      createProposal: "Create Proposal",
      bidDate: "Bid Date",
      startDate: "Start Date",
      previewAndSend: "Preview & Send",
      copyProposal: "Copy Proposal",
      contactDetails: "Contact Details",
      proposalDetails: "Proposal Details",
      enterPrices: "Enter Prices",
      projectDetails: "Project Details",
      folders: "Folders",
      chooseFolders: "Choose Folders",
      recipients: "Recipients",
      chooseVendors: "Choose Vendors",
      atLeastOneVendor: "Must select at least 1 vendor",
      atLeastOnePrice: "Must enter prices for at least 1 item",
      externalLinks: "External Links",
      addHCSSPlans: "Add HCSS Plans",
      addLinks: "Add Links",
      attachments: "Attachments",
      uploadFiles: "Upload Files",
      excelDropdownPlaceHolder: "Export",
      confirmBack:
        "You have unsaved changes. Are you sure you want to continue?",
      savingDraft: "Saving Draft",
      saveDraft: "Save Draft",
      proposalItems: "Proposal Items",
      noPricesHelpText: {
        title: "No Items",
        body: "At least 1 item must be added to the quote proposal."
      },
      noAttachmentsHelpText: {
        title: "No Attachments",
        body: "It is optional to add attachments."
      }
    },
    attachments: {
      notifications: {
        linkCopied: {
          title: "Copied!",
          message: "Link copied to clipboard"
        }
      },
      uploadFiles: "Upload Files"
    },
    details: {
      initialProposal: "Initial Proposal",
      followUp: "Follow Up",
      addendum: "Addendum",
      quoteNotes: "Proposal Notes",
      // proposalType: "Proposal Type",
      typeRequired: "Quote type is required.",
      quoteName: "Proposal Name",
      nameRequired: "Quote name is required.",
      priceExpiration: "Price Expiration Date",
      priceExpirationRequired: "Price expiration date is required.",
      firstName: "First Name",
      firstNameRequired: "Contact first name is required.",
      lastName: "Last Name",
      lastNameRequired: "Contact last name is required.",
      email: "Email",
      phone: "Phone",
      recipients: "Recipients",
      contactsRequired:
        "At least one contact is required. All contacts must have valid emails.",
      contactsPlaceholder: "Click here...",
      addContact: "Add Contact",
      sendRepliesTo: "Send Replies To...",
      noEmailProvided: "(no email)",
      receiveProposal: "Mark as Read",
      statusTitleQuestion:
        "Let {0} know you have received this quote proposal?",
      statusTitleReceived: "A read receipt has been sent to {0}.",
      statusToolTipReceived:
        "The sender has been notified that you have read the proposal they sent you."
    },
    import: {
      importExcel: "Import Prices from Excel",
      importExcelQP: "Import Items from Excel",
      step1: "STEP 1. Download the import template.",
      step2: "STEP 2. Import the Excel file.",
      subTextQP1: "Enter items and their unit prices into Excel. Save file.",
      subTextQP2: "Select the file to import the items and their unit prices.",
      subText1: "Enter unit prices in Excel for any item you want to quote.",
      subText3: "Add new items on blank rows, if needed. Save file.",
      subText2:
        "Select the file to import the unit prices for the requested items and all fields for newly added items.",
      close: "Close",
      selectFile: "SELECT FILE",
      download: "DOWNLOAD",
      importXlHeader1:
        "Enter Unit Price for requested items you intend to quote. DO NOT edit Description for requested items.",
      importXlHeader2:
        "Enter Description, Quantity, Unit, and Unit Price for any NEW items.",
      importXlHeader3:
        "When you import this saved file, all of these items will overwrite the items listed in the proposal."
    },
    prices: {
      addPrices: "Add Price"
    },
    review: {
      title: "Quote Proposal Review",
      priceExpiration: "Price Expiration Date",
      sentTo: "Sent To",
      sentFrom: "Sent From",
      code: "Code",
      name: "Name",
      location: "Location",
      jobDetails: "Job Details"
    }
  },
  solicitations: {
    notifications: {
      drafts: {
        success: "Successfully deleted draft",
        error: "Unable to delete draft"
      }
    },
    deleteConfirmationName: "Are you sure you want to delete {0}?",
    deleteConfirmationNoName: "Are you sure you want to delete (no name)?",
    draftSolicitations: "Draft Solicitations",
    sentSolicitations: "Sent Solicitations",
    columns: {
      solName: "Solicitation Name",
      name: "Name",
      createdDate: "Date Created",
      dueDate: "Date Due",
      estimateId: "Estimate Code",
      projectName: "Project Name",
      vendors: "Vendors",
      type: "Type",
      code: "Code",
      description: "Description",
      email: "Email",
      minorityType: "Minority Type",
      url: "URL",
      folder: "Folder",
      estimator: "Estimator",
      folderNotes: "Folder Notes",
      vendorCode: "Vendor Code",
      vendorName: "Vendor Name",
      lastName: "Last Name",
      firstName: "First Name",
      phoneNumber: "Phone Number"
    },
    links: {
      noDataText: "Add External Links"
    },
    vendors: {
      removeVendor: "Remove Vendor",
      chooseVendors: "Choose Vendors"
    },
    folders: {
      noFolders: "No Folders",
      noFolderInfo:
        "Invitations sent without folders/items will include project information, external links, files, and the solicitation details entered above.",
      chooseFolders: "Choose Folders",
      removeFolder: "Remove Folder",
      material: "Material",
      subcontractor: "Subcontractor"
    },
    preview: {
      notifications: {
        emailError: "Error sending emails. Please try again."
      },
      personalEmail: "Personal email account",
      viaBusinessUnitEmail: "via business unit email account",
      viaOtherEmail: "via <{0}>",
      genericEmail: "Generic email ({0})",
      loading: "Loading...",
      sendingEmail: "Sending email...",
      useCompanyEmail: "Use your company personal email account",
      personalEmailNeedsAttention:
        "Your personal email account needs attention",
      sendPreview: "Send Solicitation Preview",
      cancel: "Cancel",
      sendAll: "Send All",
      sendingFrom: "Sending From",
      sendingTo: "Sending To",
      emailSubject: "Email Subject",
      emailSubjectRequired: "Email subject is required.",
      emailPreview: "Email Preview",
      loadingPreview: "Loading Preview...",
      quoteRequestFor: `Quote request for "{0}"`,
      quoteRequest: "Quote request",
      emailNote: "Email Note",
      emailNoteLimit: "Limited to 200 characters.",
      emailNotePlaceholder: `Enter a short note for all vendors in this solicitation.\nThis note will appear in the quote solicitation email & it is limited to 200 characters. `
    },
    solicitationSetup: {
      code: "Project Code",
      codeRequired: "Project code is required.",
      name: "Project Name",
      nameRequired: "Project Name is required.",
      location: "Project Location",
      header1: "Project",
      header2: "Estimate",
      addNewProject: "Add New Project",
      detailsBelow:
        "The project details below will display on the sent solicitation...",
      projectHelp1:
        "This list is populated by the projects from Project Tracking.",
      projectHelp2:
        "You can quickly add a project by selecting the link to the right. ",
      projectHelp3: "A project name is required to send a quote solicitation.",
      estHelp1:
        "Selecting an estimate is optional. But if you want to send out quote folder items in the solicitation, you must select the estimate so that the quote folders will be available.",
      estHelp2:
        "This list is populated by the active estimates available to you.",
      estHelp3: `An active estimate is a HeavyBid estimate where you’ve enabled the estimate preference for Estimate History and have synced the quote items to this website.`,
      helpText3Est:
        "The current estimate and project must be linked for the solicitation to be sent.",
      addProjectButtonText: "Add new project",
      linkWarning:
        "The project you have selected is not yet linked to the selected estimate. Would you like to link them?",
      linkWarningEst:
        "The new project you have created is not yet linked to the current estimate. Would you like to link them?"
    },
    setup: {
      emailsSentSuccessfully: "Successfully sent emails!",
      createSolicitation: "Create Solicitation",
      bidDate: "Bid Date",
      startDate: "Start Date",
      previewAndSend: "Preview & Send",
      solicitationDetails: "Solicitation Details",
      solicitationSetup: "Solicitation Setup",
      folders: "Folders",
      chooseFolders: "Choose Folders",
      vendors: "Vendors",
      chooseVendors: "Choose Vendors",
      atLeastOneVendor: "Must select at least 1 vendor",
      requiredFields:
        "The following fields are required: Vendor Code, Vendor Name, First Name, Last Name and Email.",
      externalLinks: "External Links",
      addHCSSPlans: "Add HCSS Plans",
      addLinks: "Add Links",
      attachments: "Attachments",
      uploadFiles: "Upload Files",
      confirmBack:
        "You have unsaved changes. Are you sure you want to continue?",
      savingDraft: "Saving Draft",
      saveDraft: "Save Draft",
      noFoldersHelpText: {
        title: "No Folders",
        body:
          "Solicitations sent without folders or items will still include solicitation details, project details, external links, and attachments."
      },
      noEstimateFoldersHelpText: {
        title: "No Estimate Selected",
        body: `To select folders to solicit from, first choose an estimate in the dropdown in the 'Solicitation Setup' portion of this page. You may still solicit with no folders selected. `
      },
      noVendorsHelpText: {
        title: "No Vendors",
        body: "At least 1 vendor must be selected."
      },
      noLinksHelpText: {
        title: "No Links",
        body: "It is optional to add external site links."
      },
      noAttachmentsHelpText: {
        title: "No Attachments",
        body: "It is optional to add attachments."
      }
    },
    attachments: {
      notifications: {
        linkCopied: {
          title: "Copied!",
          message: "Link copied to clipboard"
        }
      },
      uploadFiles: "Upload Files"
    },
    details: {
      initialSolicitation: "Initial Solicitation",
      followUp: "Follow Up",
      addendum: "Addendum",
      solicitationNotes: "Solicitation Notes",
      MessageType: "Solicitation Type",
      typeRequired: "Solicitation type is required.",
      solicitationName: "Solicitation Name",
      nameRequired: "Solicitation name is required.",
      quoteDueBy: "Quote Due By",
      quoteDueByRequired: "Quote due by date is required.",
      firstName: "First Name",
      firstNameRequired: "Contact first name is required.",
      lastName: "Last Name",
      lastNameRequired: "Contact last name is required.",
      email: "Email",
      phone: "Phone"
    },
    selectFolders: {
      title: "Select Folders"
    },
    selectVendors: {
      any: "Any",
      unsolicited: "Unsolicited",
      repliedWillBid: "Replied: Will Bid",
      repliedWillNotBid: "Replied: Will Not Bid",
      submittedQuote: "Submitted Quote",
      title: "Select Vendors",
      solicitationStatus: "Solicitation Status",
      inSelectedFolders: "In Selected Folders",
      inEstimate: "In Estimate",
      vendorList: "Vendor List"
    },
    dashboard: {
      noDataTitle: "No Solicitations",
      noDataHelpText:
        " Either send a solicitation, or change your filters. Solicitations will appear under the project they belong to."
    }
  },
  quotes: {
    showQuoteSheetLink: "See Full Quote Sheet",
    filters: {
      search: "Search",
      searchQuotes: "Search Quotes",
      lastModified: "Last Modified",
      selectEstimator: "Select Estimator",
      selectDate: "Select Date",
      noEstimators: "No Estimators found",
      emptyEstimator: "None"
    },
    folderColumns: {
      folder: "Folder",
      description: "Description",
      type: "Type",
      estimator: "Estimator",
      lastModified: "Last Modified",
      selectedVendors: "Selected Vendors",
      folderTotal: "Folder Total"
    },
    vendorColumns: {
      vendor: "Vendor",
      name: "Name",
      minorityStatus: "Minority Status",
      vendorNotes: "Vendor Notes",
      selectedVendor: "Selected Vendor",
      vendorTotal: "Vendor Total"
    },
    quoteColumn: {
      code: "Code",
      item: "Item",
      selectedVendor: "Vendor",
      quantity: "QTY",
      unit: "Unit",
      amount: "Amount",
    },
    folderDetailsQuotes: {
      selectedVendorPerItem: "SELECTED VENDOR PER ITEM",
      allVendorsTitle: "ALL VENDORS IN THIS QUOTE FOLDER",
      vendors: "Vendors"
    },
    quoteFolders: "Quote Folders",
    banner:
      "HeavyBid 2022.0.0 or higher is needed in order to map and sync any vendor’s extra item prices to HeavyBid quote folders where this vendor is not currently listed.",
    overwrittenMessage:
      "For one or more items in this quote, the description, quantity, unit and/or unit price were overwritten.",
    folderSelectionClear: "(None)",
    moduleName: "Quote Management",
    awaitingResponse: "Awaiting Response",
    invitationAccepted: "Invitation Accepted",
    invitationDeclined: "Invitation Declined",
    receivedNewPrices: "Received New Prices",
    reviewed: "Reviewed",
    MarkedAsUnread: "Mark As Unread",
    rejected: "Rejected",
    status: "Status",
    folderDetails: "Folder Details",
    folderNoItemsNoVendors:
      "This folder does not contain any Quote Items or Vendors.",
    folderNoItems: "This folder does not contain any Quote Items.",
    folderNoVendors: "This folder does not contain any Vendors.",
    quotedAmount: "Quoted Amount",
    pluggedAmount: "Plugged Amount",
    adjustments: "Adjustments",
    totals: "Totals",
    item: "Item",
    resource: "Code",
    cancel: "Cancel",
    continue: "Continue",
    confirmRevertChnges: "Revert Changes",
    quantity: "Quantity",
    description: "Description",
    disabledTooltipForEditing:
      "Disable Editing mode in order to select this button.",
    code: "Code",
    unit: "Unit",
    folder: "Folder",
    unitPrice: "Unit Price",
    extendedPrice: "Extended Price",
    plugPrice: "Plug Price",
    s: "S",
    p: "P",
    subContractor: "Subcontractor",
    material: "Material",
    estimator: "Estimator",
    notes: "Notes",
    noDescription: "No Description",
    noResource: "No Resource",
    quoteHasBeenReviewed: "Quote has been reviewed.",
    quoteReviewedError: "An error occurred while updating quote.",
    quoteHasBeenMarkedAsUnread: "Quote has been marked as unread.",
    quoteHasBeenRejected: "Quote has been rejected.",
    quoteHasBeenManuallyEntered:
      "Quote will be manually entered into HeavyBid.",
    quoteChangesHaveBeenReverted: "Quote changes have been reverted.",
    quoteChangesRevertError: "An error occured while reverting quote changes.",
    quoteValidationError: "Please select a folder for at least 1 item.",
    quoteVendorFolderValidationError:
      "There is an item that cannot be mapped to the correct quote folder because this vendor is not yet in that HeavyBid quote folder for this item. Please go to HeavyBid, add this vendor to the correct quote folder and select Sync Quote Prices in the HeavyBid Quote Summary window. Once you refresh this window, then that folder selection will be available for the quote items. Proceed to map the items to the appropriate quote folder before you Mark as Reviewed.",
    quoteVendorFolderValidationErrorTitle: "Vendor Needs A Folder",
    quoteRejectedError: "An error occurred while updating quote.",
    updatingPrices: "Updating Prices...",
    ignoringPrices: "Ignoring Prices...",
    quoteDetails: "Quote Details",
    closeQuote: "Close Quote",
    revertingPrices: "Reverting to Original Prices.",
    revertModalContentLine1:
      "All edited quote item fields will be reverted to their original values.",
    revertModalContentLine2: "Do you want to continue?",
    queueForSync: {
      button: "Queue For Sync",
      disabledTitle:
        "This button will disable when prices are all zeros. Enable Editing to add the vendor prices in the quote below.",
      enableTitle:
        "Selecting Queue for Sync will queue these vendor prices to be synced with HeavyBid on the next Sync from the HeavyBid Quote Summary window"
    },
    vendorDetails: "Vendor Details",
    prices: "Prices",
    validThrough: "Valid through {0}",
    vendorNotes: "Vendor Notes",
    total: "Total",
    internalNotes: "Internal Notes",
    company: "Company",
    vendorContact: "Vendor Contact",
    folderNotFound: "This item's folder could not be found.",
    na: "N/A",
    chooseFolder: "Map Item...",
    syncRequired: "Sync Required",
    vendor: "Vendor",
    viewDetails: "View Details",
    type: "Type",
    selectedVendors: "Selected Vendor(s)",
    folderTotal: "Folder Total",
    name: "Name",
    minorityStatus: "Minority Status",
    selected: "Selected",
    vendorTotal: "Vendor Total",
    selectedVendor: "Selected Vendor",
    folderNotes: "Folder Notes",
    quoteInbox: "Quote Inbox",
    new: "New",
    pending: "Pending",
    all: "All",
    itemsBidOfTotal: "{0} of {1}",
    itemsBid: "Items Bid",
    invitedOn: "Invited On",
    lastActivity: "Last Activity",
    receivedOn: "Received On",
    reviewedOn: "Reviewed On",
    rejectedOn: "Rejected On",
    extraItems: "Extra Items",
    quoteSummary: "Quote Summary",
    gridView: "Grid View",
    listView: "List View",
    details: {
      address: "Address",
      adjExtendedPrice: "Adj. Extended Price",
      adjUnitPrice: "Adj. Unit Price",
      adjustment: "Adjustment:",
      anticipatedStartDate: "Anticipated Start Date",
      attachments: "Attachments",
      bidDate: "Bid Date",
      bidding: "Bidding",
      blanks: {
        description: "Description is required.",
        unit: "Unit is required.",
        unitPrice: "Price is required.",
        quantity: "Quantity is required."
      },
      changeStatus: "Change Status",
      clientNo: "Client #",
      company: "Company",
      contactInformation: "Contact Information",
      contacts: "Contact",
      description: "Description",
      downloadAll: "Download All",
      extendedPrice: "Extended Price",
      headerMessage: "{0} invited you to bid on {1} at {2}",
      importantDates: "Important Dates",
      itemDetails: "Item Details",
      enterPrices: "Enter Prices",
      guestUserBannerText: [
        "Do you want to see your previous quotes? Sign up for your free HCSS account!",
        "Do you want to manage your contacts and send professional looking proposals? Did I tell you it’s free?"
      ],
      guestUserBannerLinkText: "Learn more",
      job: "Job",
      jobSite: "Job Site",
      lastSubmissionMessage:
        "A quote was previously submitted on {0} at {1} for {2}.",
      location: "Location",
      mainContact: "Primary Contact",
      name: "Name",
      noItems: "No Items",
      noItemsMessage:
        "This invitation was sent without quote items. Please review the included project information, external links and/or files, and let {0} know if you are interested in bidding this project. You may optionally add additional items by clicking below.",
      noItemsAddButton: "Add Additional Items",
      notBidding: "Not Bidding",
      notes: "Notes",
      notesTooLong:
        "Please shorten the notes as it has exceeded 900,000 characters.",
      projectDetails: "Project Details",
      pageTitle: "Quote Request Details",
      print: "Print",
      projectId: "Project ID",
      projectInformation: "Project Information",
      projectName: "Project Name",
      quantity: "Quantity",
      quoteDueDate: "Quote Due Date",
      roundingDiff: "Rounding Difference:",
      reviewSubmit: "Review & Submit",
      copyProposal: "Copy Proposal",
      statusTitleNo: "You are not bidding!",
      statusTitleQuestion: "Will you be bidding on this project?",
      statusTitleYes: "You are Bidding!",
      statusTooltipNo:
        "This will let the contractor know you are not going to submit prices.",
      statusTooltipQuestion:
        "This will let the contractor know you are going to submit prices, even if you come back and do it at a later time.",
      statusTooltipYes:
        "This will let the contractor know you are going to submit prices.",
      submitPromptMessage:
        "You are about to submit quote prices on behalf of yourself or your company. After you submit you will not be able to edit your prices. Do you want to continue?",
      submitPromptTitle: "Submit Quote Prices?",
      submitting: "Submitting...",
      subtotal: "Subtotal:",
      subItem: {
        addSubitem: "Add Your First Subitem",
        add: "Add",
        save: "Save",
        cancel: "Cancel",
        removeSubitem: "Remove Subitem",
        noSubItemsHelpText: {
          title: "No Subitems",
          body:
            "Create subitems to quickly break apart larger items into smaller components. Totals will be rolled up into a final value."
        }
      },
      total: "Total:",
      unit: "Unit",
      unitPrice: "Unit Price",
      urlLinks: "URL Links",
      unitMismatchMessage:
        "There is a unit mismatch between the selected HeavyBid quote item and this Vendor’s extra item. Correct the unit in order to sync this item’s unit price back to HeavyBid.",
      confirmModal: {
        cancel: "Go Back",
        continue: "Continue"
      },
      closeQuoteModal: {
        title: "Close Quote",
        warning:
          'By selecting "Close Quote", the vendor prices WILL NOT sync back to HeavyBid Quotes.',
        prompt: "Which statement fits better?",
        overlayMessage: "Closing quote.",
        reject: {
          label: "I reject these vendor prices and will not consider them.",
          text:
            'This quote\'s solicitation card will move to the Done column with the status "Rejected", can be viewed and can be re-opened later.'
        },
        manual: {
          label: "I will manually enter the vendor prices into HeavyBid.",
          text:
            'This quote\'s soliciation card will move to the Done column with the status "Manually Entered".'
        }
      }
    },
    quoteReview: {
      title: "Quote Review",
      back: "Back To Details",
      submit: "Submit Quote",
      date: "Date",
      project: "Project",
      validThrough: "Valid through",
      total: "Total",
      submitTo: "Submit To",
      contactUs: "Contact Us",
      clientNo: "Client No.",
      description: "Description",
      quantity: "Quantity",
      unit: "Unit",
      unitPrice: "Unit Price",
      extendedPrice: "Extended Price",
      totalAmount: "TOTAL AMOUNT",
      notes: "Notes"
    },
    submission: {
      title: "Submission Successful",
      viewQuote: "View Quote",
      signupTitle: "now Available for",
      free: "FREE",
      discover: "Discover More"
    },
    emptyState: {
      title: "No folders found",
      text:
        "To get started, sync data from the Quote Summary screen in HeavyBid."
    },
    pricesLastSynced: "Prices last synced:"
  },
  userAdmin: {
    adminRequired: "You must be an admin to visit this page",
    writeRequired:
      "You must have rights to add/edit projects to visit this page",
    contactRequired:
      "You must have rights to add/edit contacts to visit this page",
    fullPreconRequired:
      "You must have full Pre-Construction access to visit this page",
    unauthorized: {
      jumbotron: {
        title: "You don't have access to Pre-Construction.",
        heavyBid: "HeavyBid Pre-Construction",
        text1: " is the home of:",
        listItem1: " with bid results tracking",
        listItem2: " with KPI analysis",
        listItem3: "Centralized ",
        text2: "Contact  your administrator and share ",
        text3: "this Help article",
        text4: " if you need access.",
        text5:
          "If you have previously updated your account, logout, then try again. If this problem persists, please contact your system administrator or click the links below for more information.",
        logout: "logout"
      },
      projectTracking: {
        title: "Project Tracking",
        body:
          "Accessing Project Tracking requires a subscription to HeavyBid Addons: Project Tracking. This change can be made in HCSS Credentials. For more information click the link below.",
        help: "Start using Project Tracking"
      },
      heavybidInsights: {
        title: "Estimate Insights",
        body:
          "Accessing Estimate Insights (formally HeavyBid Insights) data requires that you configure settings in both HeavyBid & Credentials. Steps to get started can be accessed in the HCSS Help Center.",
        help: "Start using Estimate Insights"
      },
      contactManagement: {
        title: "Contact Management"
      },
      quoteManagement: {
        title: "Quote Management",
        body:
          "The Quote Management feature is currently open to alpha users only. If you are interested in becoming an alpha or beta user, please contact us.",
        help: "Email us now"
      },
      supportPortal: {
        title: "Help & Support",
        body:
          "Have other questions or concerns? Ask questions regarding your HCSS software and get answers. Support team members are standing by to answer your questions live.",
        help: "Go to the HCSS Support Portal"
      },
      sandbox: {
        title: "Want to try out Pre-Con?",
        body:
          "Explore a sandbox environment where you can get a feel for the product!",
        help: "Explore now"
      }
    },
    permissionsUpdated: "Permissions Updated",
    errors: {
      adminRequired: "At least one Administrator is required",
      permissions: "Error Saving Permissions"
    },
    revoke: "Revoke",
    cancel: "Cancel",
    title: "User Administration",
    save: "Save",
    newPermissions: "Permissions given to newly added users:",
    addEdit: "Add and edit projects in Project Tracking",
    addEditContact: "Add and edit companies or contacts in Contact Management",
    seeHeavyBid: "See numbers from HeavyBid estimates",
    admin:
      "Administrator (set user permissions, customize Project fields, manage Project & Estimate templates)",
    estimateInsights: "Access to Estimate Insights",
    adminTooltip:
      "Users with an ‘Admin’ User Role in Credentials will be brought into this application as a Company Admin.",
    companyAdminTooltip:
      "Company Admins maintain full rights within the Pre-Con application. Their app access and User Role level is managed within HCSS Credentials.",
    limitedUserTooltip:
      "Not available for read-only users. To enable, go to HCSS Credentials and add this user to a subscription group with full-feature HeavyBid | Pre-Construction.",
    dataAccessTooltip:
      "Access to Estimate Insights and viewing of estimate cost/price values",
    writeTooltip: "Admin must be unchecked first.",
    userPermissions: "User Permissions",
    usersWithAccess:
      "These user accounts have been granted permission to access Pre-Construction in HCSS Credentials",
    revokeAdmin: "Revoke Admin Rights",
    revokeAdminConfirmation:
      "Are you sure you want to revoke Admin rights for yourself?",
    defaultNewUserPermissions: {
      projectTracking: "PROJECT TRACKING",
      contactManagement: "CONTACT MANAGEMENT",
      estimateInsights: "ESTIMATE INSIGHTS"
    },
    permissionsTable: {
      firstName: "First Name",
      lastName: "Last Name",
      userId: "User Id",
      addEdit: "Add & Edit",
      seeHeavyBid: "See HeavyBid Numbers",
      admin: "Administrator",
      estimateInsights: "Estimate Insights",
      projectTracking: "Project Tracking",
      contactManagement: "Contact Management",
      dataAccess: "Data Access"
    }
  },
  layout: {
    title: {
      heavy: "Heavy",
      bid: "Bid",
      preConstruction: "Project Tracking",
      combined: "HeavyBid Project Tracking",
      quotes: "Quotes"
    },
    loading: "Loading",
    menu: {
      title: "Menu",
      projectTracking: {
        title: "Project Tracking",
        list: "Project List",
        import: "Import",
        importProjects: "Import Projects",
        customize: "Customize Setup",
        customizeOld: "Customize Projects",
        estimateMapping: {
          title: "Estimate Mapping",
          hover: "Total Number of Unlinked Estimates"
        }
      },
      importBidResults: {
        title: "Import Bid Results",
        title1:
          "Before you start, it is important to know that bid results can only be imported into existing projects.",
        title2:
          "Use <strong>Import Projects</strong> to first create any missing projects before the bid results are imported.",
        title3:
          "Bid History data exported from HeavyBid can also be imported as bid results.",
        bidResultsXMLHeader1:
          "Use one row for every bid submission for each Project.",
        bidResultsXMLHeader2:
          "Enter the Project Name, Company Name, and Bid Total. Mark the winner for each Project by entering #Y for Yes.",
        bidResultsXMLHeader3:
          "Your Company Name is #companyName. Use this Company Name for your bid submissions.",
        projectName: "Project Name",
        winner: "Winner?",
        companyName: "Company Name",
        bidTotal: "Bid Total",
        downloadXML: "Download",
        learnMore: "Learn More",
        selectFile: "Select File",
        step1:
          "<strong>Step 1.</strong> Download the bid results import template.",
        subtitle1: "Enter any bid results into Excel. Save file.",
        step2: "<strong>Step 2.</strong> Import the Excel file.",
        subtitle2: "Select the file to import bid results.",
        cancel: "Cancel",
        preview: "Preview",
        import: "Import",
        wizardStep1: "Select File",
        wizardStep2: "Preview",
        wizardStep3: "Results"
      },
      projects: {
        import: {
          label: "Import",
          projects: "Projects",
          bidResults: "Bid Results"
        }
      },
      estimating: {
        title: "Estimate Insights",
        list: "Estimate List",
        codebooks: "Codebooks Dashboard",
        edit: "Edit Archived Estimates",
        customize: "Customize Reporting",
        activityTotals: "Activity Totals",
        recentEstimates: "Recent Estimates",
        divToBuErrorTitle:
          "We couldn't find any estimates for your current Business Unit",
        divToBuCodebooksErrorTitle:
          "We couldn't find any Codebooks for your current Business Unit",
        contactSupport: "Contact HCSS by opening a ticket at https://community.hcss.com/s/contactsupport or calling 1-855-231-7876.",
        divToBuErrorBody:
          "Click the link below for help on getting started, or contact HCSS by opening a ticket at https://community.hcss.com/s/contactsupport or calling 1-855-231-7876.",
        divToBuFilteredErrorTitle:
          "No estimates are available with the current filters",
        unauthorizedErrorTitle:
          "Please Contact your Administrator or HCSS Support",
        unauthorizedErrorBody:
          "Your account does not have access to the requested Business Unit's estimates",
        noCodebooksData: {
          title: "No Activity Codebook data is currently available to analyze",
          body: "For information on Uploading System Data to the Web"
        },
        codebookslimitedPlaceholder: {
          title: `The Codebooks Dashboard is a tool that allows you to analyze your Activity Codebook usage\n across archived and synced estimates`,
          text: "This feature is available to companies with “Full Features” access",
          fullFeaturesText: "For more information on “Full Features” access",
          moreInfoText: "For more information on the Codebooks Dashboard"
        },
      },
      contacts: {
        title: "Company Information",
        mainDetails: "Main Details",
        list: "Company List",
        search: "Search Contacts",
        import: "Import Contacts",
        setup: "Company Setup"
      },
      settings: {
        title: "Settings",
        email: "Business Unit Email",
        email2: "Company Email",
        userAdmin: "User Admin",
        companyProfile: "Company Profile",
        smtpSettings: "SMTP Settings",
      },
      quoteManagement: {
        title: "Quote Management",
        dashboard: "Dashboard",
        createProposal: "Create Proposal",
        createSolicitation: "Create Solicitation",
        incomingHeader: "Incoming Quotes",
        incomingSubHeader: "From Subs and Vendors",
        outgoingHeader: "Outgoing Proposals",
        outgoingSubHeader: "To General Contractors",
        vendorCommunication: "Vendor Communication",
        filters: "Filters",
        noVendorCommsFoundTitle:
          "We couldn't find any Solicitations or their related Vendor Communication records in any of your current Projects",
        noVendorCommsFoundBody:
          "Select 'Create Solicitation' in the left menu to send a Solicitation and automatically begin tracking your Vendor Communications."
      }
    },
    profile: {
      currentBU: "Current BU",
      bu: "Change Business Unit",
      email: "Configure Email Settings",
      calendar: "Configure Calendar Settings",
      language: "Language",
      dateTimeFormat: "Date/Time Format",
      enableSandbox: "Enable Sandbox Mode",
      logout: "Logout"
    },
    feedback: "Feedback",
    chat: {
      online: "Chat with an Expert",
      offline: "Agent offline"
    },
    help: {
      helpCenter: `Help Center`,
      chat: `Live Chat with Support`,
      contact: `Contact Support`,
      phone: `Help Line: 1-855-231-7876`,
      suggestion: `Log a Product Suggestion`,
      about: `About HCSS`,
      privacy: `HCSS Privacy Policy`,
      tutorial: `Launch Tutorial`
    },
    alphaHelp: "Alpha Help"
  },
  core: {
    dropdown: {
      clear: "(Clear)",
      placeholder: "Select",
      new: `To add a new option: type a value, press Enter`
    },
    filters: {
      title: "Filters",
      removeDisplayedFilters: `Remove Filters ({0} displayed)`,
      clearActiveFilters: `Clear Active Filters ({0} applied)`,
      textPlaceholder: "Type something and press enter...",
      addFiltersText: "Add Filters",
      adjustFiltersText: "Adjust Filters",
      collapseFiltersText: "Collapse Filters",
      expandFiltersText: "Expand Filters",
      numMin: "Min",
      numMax: "Max",
    },
    modals: {
      ok: "Ok",
      cancel: `Cancel`,
      close: "Close",
      confirmBack: {
        title: "Unsaved Changes",
        discardButton: "Discard Changes",
        saveButton: "Save Changes",
        cancelButton: "Cancel",
        unsavedChanges: `You have unsaved changes. Are you sure you want to continue?`
      },
      confirmDelete: {
        confirm: "Confirm Delete",
        projectTitle: "Delete Project",
        fieldTitle: "Delete Field",
        draft: "Delete Draft",
        message: `Are you sure you want to delete {0}?`
      },
      linkHeavyJob: {
        link: "Link",
        modalTitle: "Select a Job",
        linkJobButton: "Link this job",
        noJobsTitle: "No Jobs Found",
        noJobsText: "Ensure you have access to HeavyJob jobs in this Business Unit",
        cancel: "Cancel",
        deleteLinkJobButton: "Delete link"
      }
    },
    buttons: {
      add: "Add",
      back: "Back",
      close: "Close",
      edit: "Edit",
      delete: "Delete",
      deleteAll: "Delete All",
      import: "Import",
      cancel: "Cancel"
    },
    notifications: {
      saved: `{0} Saved!`,
      added: `{0} Added!`,
      removed: `{0} Removed!`
    },
    loaders: {
      loading: "Loading...",
      updating: "Updating..."
    }
  },
  tables: {
    group: {
      placeholder: `Drag a column header here to group by that column`,
      checklist: {
        true: "Checked",
        false: "Unchecked"
      }
    },
    add: {
      text: "Add",
      hint: "Add Entry"
    },
    edit: {
      text: "",
      hint: "Edit Entry"
    },
    delete: {
      text: "",
      hint: "Delete Entry"
    },
    commit: {
      text: "",
      hint: "Save Changes"
    },
    cancel: {
      text: "",
      hint: "Cancel Changes"
    },
    export: {
      checklist: {
        true: "Checked",
        false: "Unchecked"
      },
      pdf: {
        currentPage: `Page {0} of {1}`,
        filename: `{0}-{1}.pdf`
      },
      csv: {
        filename: `{0}-{1}.csv`
      }
    },
    options: {
      optionsHeader: "Options",
      exportHeader: "Export",
      exportCSV: "CSV",
      exportCSVFull: "Export to CSV",
      exportPDF: "PDF",
      exportPDFFull: "Export to PDF",
      bidResults: "Bid Results to CSV",
      showColumns: "Show/Hide Columns",
      activityTotals: "Activity Totals",
      highlight: "Highlight Projects",
      showBulkOperations: "Show Bulk Operations",
      hideBulkOperations: "Hide Bulk Operations",
      expandAll: "Expand All",
      collapseAll: "Collapse All",
      exportDisabledMessage:
        "Exporting is disabled until all projects and estimates have been loaded.",
      stillFetchingData: "Loading projects and estimates"
    },
    rightClickColumn: {
      sort: { asc: "Sort Ascending", desc: "Sort Descending" },
      group: "Group",
      groupBy: "Group By",
      highlight: {
        on: "Highlight",
        off: "Clear Highlight"
      },
      hide: "Hide",
      showColumns: "Show/Hide Columns"
    },
    columnChooser: {
      title: `Show/Hide Columns`,
      showAll: `Show All`,
      hideAll: `Hide All`,
      close: `Close`
    },
    highlightModal: {
      title: "Highlight Projects"
    },
    search: {
      placeholder: "Search...",
      checklist: {
        true: "Checked",
        false: "Not Checked"
      }
    },
    visibility: {
      allHidden: `All columns are hidden`,
      addColumns: "Add Columns to Grid"
    },
    summary: {
      count: "Count",
      sum: "Sum"
    }
  },
  views: {
    templateSelect: {
      create: `Create a new template named {0}`,
      unknownUser: "Unknown User",
    },
    templateAccessOptions: {
      public: "Public",
      private: "Private"
    },
    templateOptions: {
      save: "Save",
      undo: "Undo",
      options: {
        title: "Options",
        new: "Save as New Template",
        rename: "Rename Template",
        remove: "Remove Template",
        setAsDefault: "Set as Default",
        claim: "Claim Template"
      }
    },
    renameModal: {
      title: "Rename Template",
      desc: `New Name (current name is {0})`
    },
    newModal: {
      title: "Save New Template",
      desc: "Template Name"
    },
    claimModal: {
      title: "Claim Template",
      desc: "Are you sure you want to claim {0}?"
    },
    savePrivateModal: {
      title: "Save Private Template",
      desc:
        "Are you sure you want to save {0} as private? You will be unable to undo this action as you do not own this template."
    },
    confirmDelete: {
      title: "Remove Template",
      desc: `Are you sure you want to remove {0}?`
    },
    accessTooltip: {
      errors: {
        unclaimed:
          "This template must be claimed by an admin before making private",
        requiredPublic: "You must have at least one public {0} template",
        lackPermissions: "Only admins can make other user's templates private",
        readOnly: "You need project add/edit access to make your templates {0}"
      },
      accessType: {
        public: "public",
        private: "private"
      },
      schemaTypes: {
        estimateInsights: "estimate insights",
        bidResults: "bid results",
        projectList: "project list"
      }
    },
    errors: {
      uniqueName: {
        title: `Error Saving Template {0}`,
        desc: `A template already exists with this name.`
      },
      saveView: `Error Saving {0}`,
      claimView: "Error Claiming Template"
    }
  },
  errors: {
    invalidValue: `{0} has an invalid value`,
    required: `{0} is required`
  },
  projects: {
    takeoffs: {
      title: "Takeoffs",
      selectFirstRow: "Starts with row #",
      mappingsErrorNotificationTitle: "Unable to import project takeoffs.",
      rowNumber: "#",
      lastImported: "Last import: {0}",
      removedLinkWarnings: "The link to {0} will be removed. The Takeoff file does not include the linked line.",
      isLinked: "Linked",
      isLinkedHelperTitle: "Help",
      isLinkedHelperDescription: "Hover over the linked checkmark to reveal associated links.",
      links: "Links",
      biditem: "Biditem",
      activity: "Activity",
      resource: "Resource",
      agtekType: "AGTEK Structure Summary",
      customType: "Custom",
      importTakeoffs: "Import Takeoffs",
      noAccess: "Requires Add & Edit access",
      selectSourceType: "Select Import Type",
      sections: {
        fileInput: "File Import",
        columnMapings: "Column Mapping",
        preview: "Preview",
        validationResult: "Preview Validation"
      },
      supportedFileFormatsWarning: "Only {0} formats are supported",
      supportedFileFormatsHint: "Accepted file formats:  {0}",
      skipOverwrite: "Import as new takeoff line.",
      duplecateLinesWereDetected: "Row already exists. Please select an overwrite option",
      rowWillBeSkipped: "Row will be skipped.",
      overwriteRow: "Overwrite existing row {0}.",
      duplicateTakeoffs: "Similar takeoffs {0} and {1} were detected.",
      willBeNewLines: "{0} new takeoffs will be added.",
      willBeOverwriten: "{0} existing takeoffs will be updated",
      willBeSkipped: "{0} rows will be skipped.",
      willBeRemoved: "{0} rows will be removed.",
      importTakeoffsAlert: "This will overwrite any existing Takeoff files on this project. Continue?",
      invalidAgtekFile: "File not recognized as an AGTEK Structure Summary file. Please use the Custom File Import option instead.",
      limitedPreConDescription: "Upgrade to the full version of Pre-Con to import Takeoffs to your Pre-Con project.",
    },
    loading: "Loading",
    warnings: {
      titles: {
        locked: "Locked Fields",
        default: "Warning"
      },
      messages: {
        locked: "Field '{0}' is locked. Cannot update its value to '{1}'.",
        unableToAutomaticallyGeocodePlace: "Unable to automatically geocode coordinates by place '{1}' in '{0}' Field."
      },
    },
    errors: {
      save: `Error Saving Project - {0}`,
      duplicateName: `A project already exists with the name {0}`,
      requiredField: `{0} is required`,
      invalidValue: `'{0}' field has an invalid value.`,
      notInBU: `The project you tried to access is not in your current Business Unit.`,
      linkSameLocationId: "This job already links to the project",
      bulkDelete: `Failed to delete {0} project(s).`
    },
    details: {
      title: "Project Detail",
      files: "Attachments",
      estimateSelectionTable: {
        noEstimates: "No estimates have been uploaded.",
        noEstimatesLink:
          "Visit https://help.hcss.com/s/article/Overview-Estimate-History for help setting up Estimate Archive."
      },
      header: {
        back: "Back",
        save: "Save",
        expand: "Expand All",
        collapse: "Collapse All",
        downloadReport: "Download PDF",
        downloadReportSpinner: "Downloading...",
        sectionSelectionTitle: "Select the Project Detail sections to be included in PDF download",
        sectionSelectionSelectAll: "Select All",
        cancel: "Cancel",
        duplicate: "Duplicate Project",
        delete: "Delete Project"
      },
      error: {
        report: "Error downloading report for project - {0}"
      }
    },
    import: {
      button: "Import Projects"
    },
    list: {
      title: "Projects",
      tutorial: "Would you like a quick tutorial on HeavyBid Project Tracking?",
      header: {
        add: "Add Project",
        template: "Template",
        viewType: {
          list: "List",
          calendar: "Calendar",
          charts: "Charts",
          map: "Map"
        }
      },
      filters: {
        noFilters:
          "You don't have any filters. Click the add filter button below!",
        addFilters: "Add Filter",
        adjustFilters: "Adjust Filters",
        select: "Select Filters"
      },
      table: {
        noData: {
          filters: `No projects are visible with the current filters`,
          noProjects: `Click Add Project to get started`,
          noProjectsReadOnly: `No Projects to display`,
          noProjectsDueToEstimateTotalsFilters:
            "You don't have access to Estimate Insights. Please remove any Estimate filter to see projects!",
        },
        quickEntryCreate: `Create '{0}'`,
        quickEntryDisabled: "Quick entry is disabled for this column",
        noOptions: "No Options",
        createNewOptions: "To add a new option: type a value, press Enter",
        selectedProjects: "{0} Project(s) selected",
      },
      calendar: {
        options: {
          subscribe: "Subscribe to Calendar",
          month: "Month",
          week: "Week",
          day: "Day",
          agenda: "Agenda",
          viewHeader: "Calendar View"
        },
        eventWidget: {
          detailsButton: "Details",
          closeButton: "Close"
        }
      }
    },
    setup: {
      header: {
        save: "Save"
      },
      title: "Customize Projects",
      addSections: "Add Sections",
      save: "Project Setup",
      heavybidIntegration: "HeavyBid Integration",
      errors: {
        sectionName: `{0} section(s) are missing names.`,
        fieldNameMissingSingular: `1 field is missing a name in {0}`,
        excessCustomFields: `Only 3 custom fields are allowed for Basic Project Tracking. Current custom fields: {0}`,
        fullProjectTrackingOnly: `Locations, Tables, Hyperlinks and Checklists are only available for Full Project Tracking. Affected fields: {0}`,
        fieldNameMissingPlural: `{0} fields are missing names in {1}`,
        fieldNameDuplicated: `Duplicate field name, {0}, in {1} section.`,
        blankWebValue: `Blank web value in field '{0}'. Web values cannot be blank.`,
        blankChecklistValue: `Blank Checklist value in field '{0}'. Checklist values cannot be blank.`,
        blankDesktopValue: `Blank desktop value in field '{0}'. Desktop values cannot be blank.`,
        duplicateWebValue: `Duplicate web display value, '{0}', in field '{1}'. Web values must be unique and HeavyBid values must be unique.`,
        duplicateDesktopValue: `Duplicate HeavyBid display value, '{0}', in field '{1}'. Web values must be unique and HeavyBid values must be unique.`,
        duplicatedSelectionValueForTableField: `Duplicate value, '{0}', in field '{1}'. Values must be unique.`,
        blankSelectionValueForTableColumn: `Field '{0}' has blank value as an option`,
        generic: "Error Saving Project Setup"
      },
      message: {
        emptyCompanyList:
          "Please navigate to Contact Management and create a company to start using this field",
        emptyCompanyListWithFilter:
          "No companies match this field's Company Type filter",
        emptyContactList:
          "Please navigate to Contact Management and create a contact to start using this field"
      }
    },
    subscription: {
      title: "Subscription Setup"
    },
    heavyJob: {
      title: "Job Budget Progress",
      noJobLinked: "No Job Linked",
      noJobLinkedDescription: "Select a job to analyze budgets and financial progress",
      limitedPreConDescription: "Upgrade to the full version of Pre-Con to link HeavyJob to your Pre-Con project.",
      linkJobButton: "Link Job",
      changeLinkedJob: "Change Linked Job",
      unLinkJobButton: "Unlink Job",
      featureDisabled: "Feature Disabled"
    },
    estimateMapping: {
      title: "Estimate Mapping",
      buttons: {
        hide: "Hide Estimate(s)",
        unhide: "Unhide Estimate(s)",
        showHidden: "Show Hidden Estimates",
        undo: "Undo",
        undoLoading: "Loading"
      },
      projectSection: {
        linkProject: "Link to Project",
        selectProject: "Select Project to link to selected Estimate(s)",
        searchProjects: "Search Projects...",
        hideProjects: "Hide Projects with linked Estimates",
        addProject: "Add Project"
      },
      projectCard: {
        linkedEstimatesOne: "1 Linked Estimate",
        linkedEstimates: "{0} Linked Estimates",
        cancelButton: "Cancel",
        linkButton: "Link"
      },
      projectDialog: {
        title: "Linked Estimates for",
        noLinkedEstimates: "This Project has no linked Estimates",
        unlinkButton: "Unlink",
        showTotalButton: "Show Totals"
      },
      estimateTable: {
        searchEstimates: "Search Estimates...",
        selectedEstimates: "{0} Estimate(s) selected",
        estimatesLinked: "{0} Estimate(s) linked to {1}"
      },
      addProjectModal: {
        title: "Add Project",
        cancel: "Cancel",
        save: "Save",
        saveHint: "Save the Project without linking Estimates",
        saveAndLink1: "Save and ",
        saveAndLink2: "Link",
        saveAndLinkHint: "Save the Project and link selected Estimates"
      },
      notification: {
        title: "Unlinked Estimates"
      },
      sagas: {
        errors: {
          loadHiddenEstimateIds: "Error loading hidden unlinked estimates",
          updateHiddenEstimateIds: "Error updating hidden unlinked estimates"
        },
        success: {
          hide: "Estimate(s) hidden successfully",
          unhide: "Estimate(s) unhidden successfully"
        }
      },
      errors: {
        estimatesMapped: "All Estimates have been mapped.",
        estimatesMappedOrHidden: "All Estimates have been mapped or hidden.",
        noEstimatesMatchedOrHidden:
          "No Estimates are visible with the applied filters or they are hidden",
        noEstimatesMatched: "No Estimates are visible with the applied filters",
        noEstimateInsightsAccess:
          "You don't have access to Estimate Insights. Please remove Bid Total filter to see estimates",
        errorDuringUndoLinkingTittle: "Unable to Undo ",
        errorDuringUndoLinkingDescription:
          "Please try again or go to Project Details to manually unlink the estimate(s).",
        errorDuringUndoLinkingLinkText: "Open Project Details",
        errorDuringUndoLinkingNotification:
          "Unable to undo linking of estimates"
      }
    }
  },
  schemas: {
    errors: {
      save: "Error Saving Project Setup"
    },
    form: {
      lockedField: "Locked",
      required: `{0} is Required`,
      containsNotListedOptions:
        "The field '{0}' contains value not listed in options",
      multiSelectListError: "There was an error saving the multi select field"
    },
    yupValidationErrors: {
      tableField: {
        valueNotInTheList: "The table field '{0}' contains value not listed in options for the following column(s): {1} "
      },
      singleSelect: {
        valueNotInTheList: "The field '{0}' has a value not listed in options"
      },
    },
    setup: {
      fieldName: "Field Name",
      columnName: "Column Name",
      standardValues: "Standard Values",
      listValues: "Values in the List",
      required: "Required",
      webDisplayValue: "Web Display Value",
      desktopDisplayValue: "Desktop Display Value",
      enabled: "Enabled",
      editableByAdmin: "Editable by Admin only",
      managedByCompanyAdmin: "Managed by Company Admin",
      displaySum: "Display Sum",
      lockable: "Lockable",
      fieldNamePlaceholder: "Field Name",
      columnNamePlaceholder: "Column Name",
      quickEntry: "Quick Entry",
      quickEntryInfo: "Allow users to add new values as needed.",
      columnLimit: "Only 6 columns are allowed for this field.",
      addColumn: "Add Column",
      multiSelect: "Multi Selection",
      multiSelectInfo:
        "Allow users to select multiple values. Field will not be able to revert back to single selection after changes are saved.",
      multiSelectModal: {
        title: "Enable MultiSelection List",
        body:
          "Field will not be able to revert back to single selection after changes are saved."
      },
      sort: "Sort",
      sortAlpha: "Sort Values Alphabetically",
      sortAlphaShort: "Sort Alphabetically",
      customSort: "Custom Sort Values",
      customSortShort: "Custom Sort",
      fullProjectTrackingOnly:
        "Available with the full version of Project Tracking",
      fieldList: {
        section: "Section",
        addFields: "Add Fields",
        help: "Help me choose",
        dragSectionTooltip: "Drag this to the right to create a new section!",
        dragFieldTooltip: "Drag this to the section you want to add it to!",
        helpPopoverDescription: `When creating a 'New Estimate from Project Tracking' in HeavyBid,
        the value you place in this field is what will be automatically
        placed into the new estimate field to which it is mapped. You can
        map fields in 'Customize Setup', by adjusting the 'Map Fields to
        HeavyBid' as you see fit.`,
        helpPopoverTitle: "Instructions"
      },
      sections: {
        name: "Section Name",
        fields: "Fields",
        dragFields: "Drag Fields here"
      },
      examples: {
        close: "Close",
        types: "Types of Fields",
        text: {
          name: "Text",
          description:
            "Use for short pieces of information that might include numbers, letters, or both",
          examples: ["Code", "Contact Name", "Title", "Email Address"],
          alt: "Text Field"
        },
        note: {
          name: "Note",
          description:
            "Use for long descriptions or multiple lines of information",
          examples: ["Notes", "Job Description"],
          alt: "Note Field"
        },
        percentage: {
          name: "Percentage",
          description: "Use for numerical information displayed in percentages",
          examples: ["Markup %"],
          alt: "Percentage Field"
        },
        number: {
          name: "Number",
          description: "Use for numerical information (but not money)",
          examples: ["Quantity", "Age"],
          alt: "Number Field"
        },
        currency: {
          name: "Currency",
          description: "Use for dollar amounts",
          examples: ["Cost", "Price"],
          alt: "Currency Field"
        },
        date: {
          name: "Date",
          description:
            "Use for events that have a date, but where the time of day is not important",
          examples: ["Bid date", "Due date"],
          alt: "Date Field"
        },
        dateTime: {
          name: "Date/Time",
          description: "Use for events that need both a date and a time",
          examples: ["Meetings", "Deadlines"],
          alt: "Date and Time Field"
        },
        selectionList: {
          name: "Selection List",
          description:
            "Like a text field, but choose options from a limited list instead of typing in any value",
          examples: ["Status", "Business unit", "Region"],
          alt: "Selection List Field"
        },
        hyperlink: {
          name: "Hyperlink(s)",
          description: "Use for linking to other websites",
          examples: ["Dropbox", "Google Drive", "DOT bid listings"],
          alt: "Links Field"
        },
        yesNo: {
          name: "Yes/No",
          description:
            "Use for simple on/off options, such as on/off, yes/no, true/false",
          examples: ["Needs Approval", "Reviewed"],
          alt: "Checkbox Field"
        },
        checklist: {
          name: "Checklist",
          description: "Use for tracking simple on/off options",
          examples: ["Completed", "Tracked"],
          alt: "Checklist Field"
        },
        location: {
          name: "Location",
          description:
            "Use for dropping a pin to show the location of a project",
          alt: "Location Field"
        },
        states: {
          name: "List of States"
        },
        custom: {
          name: "Custom"
        },
        bidResults: {
          name: "Bid Results"
        },
        estimates: {
          name: "Estimates"
        },
        preconId: {
          name: "Pre-Con ID"
        },
        company: {
          name: "Company",
          description: "Use for selecting a company for a project",
          examples: ["On-site Sub", "Trucking Sub"],
          alt: "Company Field"
        },
        contact: {
          name: "Contact",
          description: "Use for selecting a contact for a project",
          examples: ["Project Admin", "Dispatcher"],
          alt: "Contact Field"
        },
        // hJJob: {
        //   name: "Job",
        //   description: "Use to tie a HeavyJob job to Project",
        //   alt: "Job Field",
        //   empty: "No jobs available for this Business Unit",
        //   noAccess: "You do not have access to view this job.",
        //   noAccessCode: "----"
        // },
        table: {
          name: "Table",
          description: "Use for creating a table in a project",
          alt: "Table Field",

        },
        calculated: {
          name: "Calculated",
          description: "Use for creating a dynamically calculated value in a project",
          alt: "Calculated Field",
        }
      },
      calculated: {
        variablesNamesColumn: "Variable Name",
        variablesFieldsColumn: "Value",
        variablesTableName: "Calculation Values",
        addVariableBtn: "Add Value",
        addVariableTooltip: "A Number field, Currency field, or Table field with a Number column set to ‘Display Sum’ must be set up before adding a Calculation Value",
        formulaInputLabel: "Formula",
        previewLabel: "Preview",
        chooseProject: "Choose Project",
        errors: {
          invalidFormula: "Invalid formula.",
          invalidFormulaVariable: "Unknown variable {0}.",
          invalidFormulaConstant: "Invalid constant value {0} .",
          invalidFormulaOperator: "Unknown operator {0}.",
          invalidVariableField: "Variable value does not exist.",
          duplicateVariableName: "Variable name already exists.",
          invalidVariableName: "Variable name invalid.",
          requiredVariableName: "Variable name required.",
          invalidCalculationField: "Invalid {0} calculated field setup.",
          maxLength: "Variable name to long."
        },
        instructionsTooltip: {
          header: "Instructions",
          description: "Type in a formula using the variable of the assigned value along with the operator for the formula",
          allowedOperators: "Allowed operators:",
          exampleFormula: "Example formula:",
        },
        hideCalculations: "Hide calculations",
        showCalculations: "Show calculations"
      },
      selectionList: {
        deleteAllDescription: "Delete all values in the selection list?",
        import: {
          importValues: "Import Values",
          selectFile: "Select File",
          preview: "Preview",
          filesDescription: "Import values into the selection list from an Excel or CSV file.",
          pleaseNote: "Please Note",
          noteDescription: "Only the first two columns are imported into the selection list",
          skipFirstRow: "First row contains column headers",
          previewColumn: "Column",
          webValue: "Web Value",
          desktopValue: "Desktop Value",
          previewDescription: "If a value is left blank, the corresponding Web or Desktop Value in the row will be duplicated to fill the blank.",
          notSupportedFile: "Accepted file formats: {0}",
          importSucceed: "The values have been successfully imported and added to the selection list!",
          importAgain: "Import Again"
        }
      },
      checklist: {
        items: "Checklist Items",
        addBtn: "Add",
        description: "Description"
      },
      canBeImported: "Able to be imported",
      canBeSyncedWithHB: "Able to be synced with HeavyBid",
      number: {
        number: "Number",
        percentage: "Percentage"
      },
      contact: {
        filterBy: "Filter by Scope of Work",
        filterPlaceholderText:
          "Please navigate to Contact Management and create a scope of work to start using this filter"
      },
      company: {
        filterBy: "Filter by Company Type",
        filterPlaceHolderText:
          "Please navigate to Contact Management and create a company type to start using this filter"
      },
      errors: {
        tableField: {
          atLeastOneColumn: "Please add at least one column.",
          exceedColumnNumberLimit: `A table can only have total of {0} columns.`,
          duplicatedColumName: "Duplicate column names are not allowed. Please ensure that the column names are unique.",
          columnMustHasName: "A column must have a name."
        },
      },
      banner: {
        copied: `Copied "{0}" field settings from {1} business unit.`,
        multiSelectWarning: "Field will not be able to revert back to single selection after changes are saved.",
        hbMappingsWarning: "Notice: The HeavyBid Integration mappings will not be copied over.",
        copiedFromTable: `{0} copied from table '{1}' in {2}.`,
        copiedFrom: `{0} copied from {1}.`
      },
      buttons: {
        undo: "Undo",
        copyFrom: "Copy from"
      }

    },
    location: {
      geocoder: {
        placeholder: "Search for an address or lat/long",
        dropLatLongPin: "Drop pin at Latitude: {0} and Longitude: {1}",
        errorFetchingData: "There was an error fetching data. Please try again."
      }
    }
  },
  import: {
    selectedFile: "Selected File",
    sheetSelector: "Sheet Selector",
    supportedProjectsFileFormats: "Only .xls and .xlsx formats are supported",
    acceptedFileFormat: "Accepted file formats: .xls, .xlsx",
    dropFileOrClickHere: "Please drop your file here or click to select",
    acceptableValues: "Acceptable values",
    adminOnly: "This field is available to admins only.",
    acceptableContactValues: "A value must be in the following format: [first name] [last name], [email]. Email is optional",
    acceptableContactValuesDescription: "A contact's First and Last Name is required, separated by a space. A contact's Email is optional, separated from the Name by a comma. A contact's Email can be used to distinguish contacts with the same name in different companies.",
    acceptableValuesOptions: "Y/N, Yes/No, True/False, T/F, 1/0",
    acceptableLocationValues: "#.###,#.###",
    acceptableLocationValuesWithGeocoding: "Note: Only valid lat/long (in the format ##.###,##.###) or valid address (in the format street address, city, state, zip code) will show on the map",
    acceptableLocationValuesDescription:
      "A comma separated Lat,Long value with valid ranges [-90, 90] for latitude and [-180, 180] for longitude",
    exampleValueList: "Example list of values:",
    acceptedState: "Accepted values: Two-character state code",
    acceptedStateExample: "(i.e. TX)",
    acceptedCompanyValue: "“Name” from existing company in Company List",
    acceptableCompanyValuesDescription: "Company name is not case sensitive",
    percentageExample: "Use the decimal value for percent fields. Ex: importing '0.7' will display as '70%'",
    multiSelectSeparators: {
      title:
        "Choose a separator for multi-select fields that contain multiple values",
      comma: "Comma (A,B)",
      semicolon: "Semicolon (A;B)",
      pipe: "Pipe (A|B)"
    },
    importResults: {
      title: "Import Results",
      previewValidation: "Preview Validation",
      emptyMessage: "Please begin import to view results"
    },
    validationResults: {
      title: "Preview Validation",
    },
    required: "Required",
    title: "Import Projects",
    input: {
      title: "File Import",
      noFile: "No file chosen",
      supportedFormat: "Supported format: .xlsx, .xls"
    },
    settings: "Settings",
    settingOptions: {
      skip: "Skip",
      overwrite: "Overwrite"
    },
    recordExists: {
      title: "If a record in the file already exists",
      skip: "Skip the record",
      overwrite: "Overwrite the record",

    },
    firstRowHeadings: "First row contains column headers",
    fields: "Fields",
    excelColumn: "Excel Column",
    columnMapping: {
      title: "Column Mapping"
    },
    clear: "Clear",
    preview: {
      title: "Preview",
      emptyMessage: "Please upload file to preview"
    },
    import: "Import",
    cancel: "Cancel",
    finish: "Finish",
    projectsCreated: `{0} project(s) added`,
    projectsUpdated: `{0} project(s) updated`,
    created: `{0} project(s) with bid results added`,
    updated: `{0} project(s) with bid results updated`,
    importSpinner: "Importing...",
    importComplete: "Complete!",
    validationSpinner: "Validation...",
    validationComplete: "Complete!",
    importFailStartAgain: "Please start again!",
    validateSpinner: "Validating",
    validationSuccess: "Validation Success",
    skipped: `{0} skipped`,
    viewErrors: "View errors",
    validationWarnings: "Validation Warnings",
    row: "Row",
    project: "Project",
    errors: {
      mappingsErrorNotificationTitle: "Unable to import projects.",
      mappingsErrorNotificationMessage: "Please review your column mapping.",
      read: {
        title: "Error reading file",
        message: "There was an error reading the selected file."
      },
      required: {
        title: "Required field not assigned",
        message: `{0} is a required field and needs to be assigned to an Excel column`
      },
      invalid: {
        title: "Invalid Entry",
        message: `Value must be a letter`
      },
      duplicate: {
        title: "Duplicate Value",
        message: `{0} has same Excel column assignment`
      },
      rowValidation: `{0} and has been skipped`,
      duplicateRow: `Has been skipped because project {0} already exists.`,
      genericImport: `A project name {0} failed to import.`,
      invalidColumn: ` {0}, has an invalid value {1}.`,
      lockedField: ` {0}, cannot import to a locked field.`,
      requiredColumn: ` {0} is missing a required field,`,
      missingValue: ` {0}, has a value {1} that doesn't match the current selection list options,`,
      missingMultiValue: ` {0}, has values {1} that don't match the current selection list options,`,
      fileType: {
        title: `Incorrect file type ({0})`,
        message: `Only .xlsx & .xls file types are supported`
      },
      fieldsValidation: {
        invalidTextValue: "Invalid text value '{0}' in {1}' field.",
        invalidLinksValue: "Invalid links value '{0}' in {1}' field.",
        invalidChecklistValue: "Invalid checklist value '{0}' in '{1}' field.",
        invalidPreConIdValue: "Invalid PreCon id value '{0}' in '{1}' field.",
        invalidPreConIdPrefix:
          "Invalid PreCon id prefix value '{0}' in '{1}' field.",
        invalidBidResultsValue: "Invalid bid results value '{0}' in '{1}' field.",
        invalidEstimatesValue: "Invalid estimates value '{0}' in '{1}' field.",
        invalidNumberValue: "Invalid number value '{0}' in '{1}' field.",
        invalidDateValue: "Invalid date value '{0} in '{1}' field.",
        invalidBooleanValue: "Invalid boolean value '{0}' in '{1}' field.",
        invalidListSelection: "Invalid selection '{0}' in '{1}' field.",
        invalidLocationValue: "Invalid location value '{0}' in {1}' field.",
        invalidLocationLatitudeValue:
          "Invalid location latitude '{0}' in '{1}' field.",
        invalidLocationLongitudeValue:
          "Invalid location longitude '{0}' in '{1}' field.",
        noAccess: "You have no access to edit '{1}' field.",
        duplicateEstimates: "Duplicate estimates are linked to this project. Remove one of the duplicates from '{1}' then save your project.",
        locked: "The '{1}' field is locked.",
        required: "A required '{1}' field is missing.",
        rowWillBeSavedInInvalidState: "The row will be saved in invalid state.",
        invalidValuesWillBeSkipped: "Invalid values will not be imported.",
        invalidValuesWereSkipped: "Invalid values were not imported.",
        invalidTableColumnsValue: "Invalid table column count for '{1}' field. Table field must have at least 1 column.",
        maxTableColumnsCount: "Invalid table column count for '{1}' field. Table field can have 6 columns at max.",
        duplicatedContactWithProvidedInfo: "Invalid contact for '{1}' field. There are two or more contacts in Contact Management that matches the given info {0}. Please revise the name for those contacts.",
        notFoundContactWithProvidedInfo: "Invalid contact for '{1}' field. There are no contacts in Contact Management that matches the given info {0}. Please consider creating the contact.",
        firstAndLastNameAreRequiredForContactSearch: "Invalid contact for '{1}' field. First and last name is required.",
        invalidImportContactFormat: "Invalid contact format for '{1}' field. Accepted format is: '[first name] [last name], [email]'.",
        duplicatedCompanyWithProvidedName: "Invalid company name for '{1}' field. There are two or more companies in Contact Management that have the name of {0}. Please revise the name for those companies.",
        notFoundCompanyWithProvidedName: "Invalid company name for '{1}' field. There are no companies in Contact Management that have the name of {0}. Please consider creating a company with the name {0}.",
        unableToAutomaticallyGeocodePlace: "Unable to automatically geocode coordinates by place {0} in '{1}' Field.",
        valueImportedAsAddressText: "Value imported as address text.",
        invalidTakeoffsValue: "Invalid takeoff value {0}.",
        maxTakeoffsNumber: "The limit of 1000 takeoffs has been exceeded. You currently have {0} rows.",
        invalidTakeoffRow: "Invalid takeoff row [{0}].",
        invalidTakeoffField: "Invalid takeoff {0} field.",
        invalidTakeoffId: "Invalid takeoff id {0}.",
        requiredTakeoffField: "Required takeoff {0} field is missing.",
        duplicateProjectName: "Invalid Project name {0}. Project names must be unique."
      },
      locationType: {
        invalidLatitude:
          "{0} has an invalid latitude value. It must be between -90 and 90.",
        invalidLongitude:
          "{0} has an invalid longitude value. It must be between -180 and 180.",
        isNullIsland:
          "{0} has an invalid value. Location is set to Null Island (0,0)."
      }
    },
    notes: {
      warning: "Warning",
      note: "Note",
      preConIdDisabled: `You have the {0} field set to 'disabled'`,
      preConIdEnable: `You have the {0} field set to "enabled"`,
      preConIdWillBeSet: `Therefore, {0} field values for the new project(s) will be auto-generated`,
      preConIdWillNotBeSet: `Therefore, {0} field values for the new project(s) will not be auto-generated`,
      noProjectsWithPreConId: `However, there are currently no projects that have a value for the {0}
      field. Therefore, {0} field values for the new project(s) will not be auto-generated`,
      pleaseEnablePreConId: `If you want these values auto-generated, please enable the {0} field in Customize Setup > Projects`,
      createProjectWithPreConId: `If you want these values auto-generated, please save a project with a {0} value first`,
      pleaseDisablePreConId: `If you do not want these values auto-generated, please disable the {0} field
      in Customize Setup > Projects`,
      nextPreConId: `The next {0} field value is`,
      allCurrentProjectsDontHavePreConId: `However, there are currently no projects that have a value for the {0}
      field. Therefore, {0} field values for the new project(s) will not be auto-generated`
    }
  },
  charts: {
    types: {
      pie: "Pie",
      line: "Line",
      bar: "Bar"
    },
    options: {
      title: "Chart Options",
      type: "Chart Type:",
      layout: {
        title: "Layout:",
        vertical: "Vertical",
        horizontal: "Horizontal"
      },
      projectCount: "Project Count",
      total: "Total",
      xAxis: "x-Axis:",
      groupBy: "Group By:",
      yAxis: "y-Axis:",
      totalBy: "Total By:",
      selectField: "Select Field:",
      sliceOptions: "Slice Options:",
      inputPlaceholder: "Select",
      clear: "(clear)"
    }
  },
  bidResults: {
    title: "Bid Results",
    table: {
      noData: "Add Bid Results",
      noDataReadOnly: "No Bid Results to Display",
      leftOnTable: "Left on Table",
      percentFromLowBid: "% From Low Bid",
      fromLowBid: "From Low Bid",
      winner: "Winner",
      companyName: "Company Name",
      amount: "Bid Total",
      share: "Share",
      copySuccess: "Added to clipboard!",
      copySuccessTwo:
        "Paste your bid results into Excel or in the body of an email.",
      copyFailure: "There was a problem copying your bid results.",
      copyFailureTwo:
        "Please make sure you are on a browser that is compatible with this application."
    },
    view: {
      toolTip: {
        statsFor: "Stats for",
        won: "Won",
        lost: "Lost",
        dollars: "Dollars",
        percent: "Percent",
        hitRatio: "Hit Ratio",
        fromLowBid: "From Low Bid",
        leftOnTable: "Left on Table"
      }
    }
  },
  calendars: {
    subscribePanel: {
      title: "Subscribe to Calendars",
      links: "These links are unique to your account",
      visible: "iCal calendars are visible to anyone with the link",
      openAccountSettingsButton: "Open calendar settings",
      openAccountSettingsAfter: " to link external accounts"
    },
    card: {
      copy: {
        title: "Copied to Clipboard",
        message: `Calendar link copied for {0}`
      },
      readlonlyLinkLabel: "Shareable iCal Link (read only)",
      nylasLinkLabel: "Outlook Calendar",
      createLink: "Create Link",
      createReadonlyLink: "Create Shareable iCal Link",
      createNylasLinkk: "Create Outlook Connection",
      deleteReadonlyLink: "Delete iCal Link",
      deleteNylasLink: "Delete Outlook Connection",
      options: "Options",
      deleteReadonlyConfirmation: `Are you sure you want to delete your existing iCal link? This will break existing integrations.`,
      deleteHcssConnectConfirmation: `Are you sure you want to delete your existing connected calendar link? This will remove the existing events from your linked calendar.`,
      deleteReadonlyWarning:
        "This will delete your existing iCal link, which will break existing integrations.",
      deleteNewReadonlyLink:
        "A new link will be created to replace the old one.",
      deleteHcssConnectWarning:
        "This will delete your existing calendar events from the currently linked calendar.",
      deleteNewHcssConnectLink:
        "New events will be created on the newly linked calendar.",
      deleteTitle: "Delete Link",
      continue: "Continue",
      cancel: "Cancel",
      lastSync: `Last sync: {0}`,
      none: "none",
      syncWarning:
        "Your calendar client may take between a few minutes and a few hours to update. Check your client’s settings if you need quicker updates."
    }
  },
  hcssConnect: {
    subscribePanel: {
      title: "Connect Your Calendar Accounts",
      connectAccountButton: "Connect a New Account",
      linkedAccounts: "Linked Accounts"
    },
    card: {
      delete: "Delete",
      deleteConfirmation: `Are you sure you want to delete your existing calendar account? This will break existing integrations.`,
      deleteTitle: "Delete Link",
      continue: "Continue",
      cancel: "Cancel",
      deletePopover: `Remove all existing Outlook calendar connections in the "Subscribe to Calendar" panel before removing this account.`
    }
  },
  tutorials: {
    close: {
      message: "You can always access this tutorial by going to the help menu!",
      button: "Close"
    },
    banner: {
      yes: "Yes",
      no: "No"
    },
    projectTutorial: {
      create: "This allows you to create a new project.",
      details:
        "Clicking on the project name allows you to make changes to the project after it has already been created.",
      rearrange:
        "Columns can be rearranged by clicking and dragging the column headers left or right.",
      group:
        "Click and drag the column header into this area to group results by that column.",
      other:
        "Other customizations and reports are available from the options menu or by right clicking a column header.",
      save:
        "Once you have the table setup in the way you like, you can save it as a template. Use the options menu to save new templates, or to select a default one.",
      customizable:
        "Remember, everything in Project Tracking is customizable! Use the Project Tracking menu to access the Customize Projects page, or to import any existing projects from Excel.",
      complete: "Complete Tutorial!"
    }
  },
  smtp: {
    title: "Email Server Settings",
    subtitle: `Configure the email settings for business unit: {0}`,
    subtitle2: `Configure company email settings`,
    cancel: "Cancel",
    save: "Save & Test",
    oauth:
      "Personal email settings have been configured for the current user. These settings will supersede all other configurations when sending emails.",
    home: "Home",
    previouslyConfigured:
      "SMTP settings have been configured for this business unit. If necessary, you can provide new settings.",
    changeSettings: "Change Settings",
    resend: "Resend Test Message",
    username: "Username",
    server: "Server",
    port: "Port",
    password: "Password",
    validations: {
      serverAddressBlank: "Server Address can't be blank.",
      portBlank: "Port can't be blank.",
      usernameBlank: "Username can't be blank.",
      passwordBlank: "Password can't be blank."
    },
    messages: {
      saved: {
        success: {
          title: "Saved",
          message: "SMTP settings for this business unit have been saved."
        },
        error: {
          title: "Unable to Save",
          message: "An error occurred while trying to send the test message."
        }
      },
      test: {
        success: {
          title: "Test Message Sent",
          message: `A test message was sent to "{0}".`
        },
        unable: {
          title: "Unable to Send",
          message: "An error occurred while trying to send the test message."
        },
        failure: {
          title: "Failed to Send",
          message: "The current user doesn't have a valid email address."
        }
      }
    }
  },
  users: {
    messages: {
      saved: {
        success: "User Preferences",
        error: "Error saving user preferences"
      }
    },
    oAuthConfig: {
      getUserError: {
        title: "Error",
        message: "Unable to retrieve your email settings"
      },
      testMessageError: {
        title: "Test Failed",
        message:
          "Unable to send test messageg. Check to make sure your login hasn't expired."
      },
      testMessageSuccess: {
        message: `Test message successfully sent {0}.`,
        title: "Test successful!"
      }
    }
  },
  heavyBid: {
    integrationSetup: {
      sections: {
        dataSyncPreferences: {
          title: "Data Sync Preferences",
          description: "This setting manages the data priority for mapped fields during a sync with HeavyBid. If you are unsure what to choose, pick {0}.",
          descriptionBold: "Neither",
        }
      }
    },
    code: "Code",
    name: "Name",
    description: "Description",
    lastActivity: "Last Activity",
    activeEstimate: "Synced Estimate",
    excludedEstimate: "Excluded Estimate",
    division: "Division",
    projectName: "Project Name",
    projectNumber: "Project Number",
    status: "Status",
    engineer: "Engineer",
    estimator: "Estimator",
    owner: "Owner",
    bidDate: "Bid Date",
    startDate: "Start Date",
    reviewDate: "Review Date",
    createdDate: "Created Date",
    bidTotal: "Bid Total",
    totalCost: "Total Cost",
    state: "State",
    processedStatus: {
      title: "Processed Status",
      0: "Queued",
      1: "Processing",
      2: "Success",
      3: "Failure",
      4: "Queued Large"
    },
    typeOfWork: "Type of Work",
    filter1: "Tag 1",
    filter2: "Tag 2",
    filter3: "Tag 3",
    filter4: "Tag 4",
    filter5: "Tag 5",
    filter6: "Tag 6",
    text1: "Text 1",
    text2: "Text 2",
    text3: "Text 3",
    text4: "Text 4",
    text5: "Text 5",
    text6: "Text 6",
    text7: "Text 7",
    text8: "Text 8",
    text9: "Text 9",
    text10: "Text 10",
    text11: "Text 11",
    text12: "Text 12",
    text13: "Text 13",
    text14: "Text 14",
    text15: "Text 15",
    text16: "Text 16",
    text17: "Text 17",
    text18: "Text 18",
    text19: "Text 19",
    text20: "Text 20",
    integer1: "Integer 1",
    integer2: "Integer 2",
    integer3: "Integer 3",
    integer4: "Integer 4",
    integer5: "Integer 5",
    number1: "Number 1",
    number2: "Number 2",
    number3: "Number 3",
    number4: "Number 4",
    number5: "Number 5",
    number6: "Number 6",
    number7: "Number 7",
    number8: "Number 8",
    number9: "Number 9",
    number10: "Number 10",
    number11: "Number 11",
    number12: "Number 12",
    number13: "Number 13",
    number14: "Number 14",
    number15: "Number 15",
    number16: "Number 16",
    number17: "Number 17",
    number18: "Number 18",
    number19: "Number 19",
    number20: "Number 20",
    date1: "Date 1",
    date2: "Date 2",
    date3: "Date 3",
    date4: "Date 4",
    date5: "Date 5",
    address: "Location",
    latitude: "Latitude",
    longitude: "Longitude",
    manhours: "Manhours",
    estimatesExtended: "EstimatesExtended",
    estimateInfo: "Estimate Info",
    tags: "Tags",
    userDefinedText: "User Defined Text",
    userDefinedIntegers: "User Defined Integers",
    userDefinedNumbers: "User Defined Numbers",
    userDefinedDates: "User Defined Dates",
    projectTrackingField: "Project Tracking Field",
    heavyBidField: "HeavyBid Field",
    heavyBidInfo: `HeavyBid 2019.1 and 2020.0 systems will say 'New Estimate from HeavyBid Pre-Construction'. This integration is available to all systems starting with HeavyBid 2020.2`,
    multiSelectSyncInfo:
      "If a MultiSelect List field is mapped to a HeavyBid field and the Project Tracking data sync preference is chosen, then only first value in the list will be synced to HeavyBid. The first value is determined by the sort order chosen in the field options."
  },
  region: {
    us: "United States",
    au: "Australia",
    fr: "France",
    gb: "United Kingdom",
    es: "Spain",
    de: "German",
    ca: "Canada"
  },
  account: {
    confirm: {
      confirm: "Continue",
      confirming: "Confirming",
      discover: "Discover More",
      enterEmail: "Enter your email address to see quote details.",
      invalidEmail: "A valid email address is required.",
      invalidMessage: "Incorrect email or link.",
      verifyTitleRfq: "Verify your email address to see quote details",
      verifyTitleProposal:
        "Verify your email address to see the quote proposal",
      signIn: "Already have an account? Sign-In",
      signUp: "Sign Up Now",
      slogan: "One website for all your bid management needs",
      welcome: "Welcome",
      modules: {
        projects: "Track projects from start to finish",
        estimates: "Bid faster and smarter",
        quotes: "Easily manage the solicitation and quote process",
        messages: "Get real-time notifications",
        contacts: "Manage all your contacts in one place"
      }
    },
    login: {
      discover: "Discover More",
      login: "Login",
      feature1: "Estimate your quote once and send to multiple contractors.",
      feature2: "Access your quote online.",
      feature3: "Keep track of communications.",
      feature4: "Send quotes to any general contractor.",
      feature5: "Generate professional proposals for your quotes.",
      feature6: "Manage your contacts online.",
      signUp: "Learn More",
      subTitle1: "Your versatile quote",
      subTitle2: "management solution."
    },
    emailVerification: {
      success: "You're all set!",
      successMsg:
        "We were able to successfully verify your email. Give us a few minutes to look for any other quotes linked to your email address. Click the button below to navigate back to the home page.",
      successBtn: "Go to Home Page",
      fail: "OOPS!",
      failMsg:
        "Something went wrong with verifying your email. Please try to click the link from our confirmation email again."
    }
  },
  breadcrumbs: {
    dashboard: "Dashboard",
    quotes: "Quotes",
    quoteDetails: "Current Quote"
  },
  genericModal: {
    cancel: "Cancel",
    close: "Close",
    confirm: "Confirm",
    continue: "Continue"
  },
  loaders: {
    loading: "Loading...",
    updating: "Updating..."
  },
  maps: {
    default: "Default",
    satellite: "Satellite"
  },
  notFound: {
    back: "Back to Homepage",
    message: "We can't seem to find the page you requested.",
    title: "There's nothing here"
  },
  genericError: {
    back: "Back to Homepage",
    message:
      "There's been an issue on our end. We're working as fast as possible to get things back up and running. Contact HCSS Support if you need help immediately.",
    title: "Something went wrong"
  },
  smartdrive: {
    copyLink: "Copy Link",
    download: "Download",
    size: "Size:",
    uploaded: "Uploaded:",
    deleteFile: "Delete File?",
    deleteMessage: "Are you sure you want to delete ",
    warning: "Warning: This action is immediate and cannot be undone.",
    confirm: "Confirm Delete",
    cancel: "Cancel",
    table: {
      uploadFiles: "Upload Files",
      download: "Download",
      selected: "Selected",
      all: "All",
      delete: "Delete",
      noFiles: "No Files to display"
    }
  },
  groupSubMenu: {
    week: "Week",
    month: "Month",
    year: "Year",
    day: "Day",
    quarter: "Quarter"
  },
  common: {
    create: "Create",
    modules: {
      projectTracking: "Project Tracking",
      estimating: "Estimate Insights",
      quotes: "Quote Management",
      contacts: "Contact Management",
      notifications: "Notifications"
    }
  },
  comingSoon: {
    title: "Coming Soon",
    contactsText:
      "Manage all your contacts in one place, automatically keep information up-to-date, access contacts across HCSS Apps and more. Get the most out of your experience with a host of powerful and seamless integrations.",
    notificationsText:
      "Stay informed of important app updates. View and manage multiple notifications at once — helping you reduce interruptions throughout the day."
  },
  contact: {
    contactColumnNames: {
      firstName: "First Name",
      lastName: "Last Name",
      title: "Title",
      cellNumber: "Cell Number",
      phoneNumber: "Phone Number",
      emailAddress: "Email Address",
      mainContact: "Main Contact",
      office: "Office",
      notes: "Notes",
      scopes: "Scopes"
    },
    vendorColumnName: {
      code: "Code",
      heavyBidCode: "Vendor Code",
      name: "Name",
      type: "Type",
      isBonded: "Is Bonded",
      bondRate: "Bond Rate %",
      products: "Scopes of Work",
      notes: "Notes",
      accountingCode: "Accounting Code"
    },
    vendorList: {
      confirmDelete: "Delete Company"
    },
    contactList: {
      confirmDelete: "Delete Contact"
    },
    mainInfo: {
      code: "Code",
      name: "Name",
      email: "Email",
      phoneNumber: "Phone",
      communicationMethod: "Communication Method",
      webAddress: "Website",
      companyType: "Company Type",
    },
    detailInfo: {
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      city: "City",
      stateProvince: "State/Province",
      postalCode: "Zip Code",
      countryRegion: "Country",
      faxNumber: "Fax",
      note: "Notes",
      isBonded: "Is Bonded",
      bondRate: "Bond Rate %",
      accountingCode: "Accounting Code",
      clear: "(Clear)",
      administrativeDivisions: {
        states: "States",
        provinces: "Provinces"
      }
    },
    scopeOfWork: {
      select: "Select Scopes",
      scopesOfWork: "Scopes of Work"
    },
    minorityStatus: {
      confirmDelete: "Delete Minority Status",
      minorityStatuses: "Minority Statuses",
      notice: "first save your vendor before you can add MS's"
    },
    setup: {
      errors: {
        companyTypeFilterRequired: "At least one filter is required for Company Type filter for field '{0}'",
        contactTypeFilterRequired: "At least one filter is required for Scope of Work filter for field '{0}'",
        tableTypeEmptyColumn: "The table field '{0}' requires at least 1 column",
        tableTypeMoreThan6Columns: "The table field '{0}' cannot have more than 6 columns"
      }
    },
    import: {
      errors: {
        officeNicknameRequired: {
          title: "nicknameRequired",
          message:"Nickname required when mapping address fields"
        }
      }
    }
  },
  unsupportedBrowser: {
    iFrameFallback: "Unable to display content. This browser is not supported.",
    bannerTitle:
      "You may experience performance issues and bugs in your current browser.",
    bannerDetail: "See a full list of HCSS recommended browsers",
    here: "here",
    dismiss: "Dismiss"
  },
  autoSaveIndicator: {
    saving: "Saving...",
    saved: "Saved",
    errorText: "We encountered an issue. Click here to try again."
  },
  estimatesLoadIndicator: {
    loading: "Loading..."
  },
  remarkable: {
    estimateInsights: {
      textHeader: "You were tagged in a comment on an Estimate ({0}):"
    },
    projectTracking: {
      textHeader: "You were tagged in a comment on a Project ({0}):"
    },
    quoteManagement: {
      textHeader:
        "You were tagged in a comment on a quote sent to {0} {1} from {2}:"
    }
  },
  modals: {
    columnChooserModal: {
      title: "Show/Hide Columns",
      kpisTitle: "Show/Hide KPIs",
      buttons: {
        hide: "Hide All",
        show: "Show All",
        collapseAll: "Collapse All",
        expandAll: "Expand All",
        close: "Close"
      },
      inputs: {
        search: {
          label: "Search",
          placeholder: "Search fields..."
        },
        dropdown: {
          sortBy: {
            label: "Sort by",
            placeHolder: "Sort by..."
          },
          sortByOptions: {
            default: "Default",
            alphabetically: "Alphabetically",
            fieldType: "Field Type"
          }
        },
        radio: {
          summaryType: {
            label: {
              sum: "Sum",
              avg: "Avg"
            }
          }
        }
      },
      noData: {
        title: "No results found"
      }
    }
  },
  emailSubscription: {
    projectTemplatesDropdown: {
      label: "Project List Template(s):"
    },
    recipientsDropdown: {
      label: "Recipient(s):"
    },
    subscriptionDetail: {
      defaultName: "Project List Email Subscription",
      labels: {
        description: "Description:",
        emailSubject: "Email Subject:"
      },
      buttons: {
        save: "Save",
        preview: "Preview",
        bulkEditRecipients: "Bulk Edit Recipients",
        copyRecipients: "Copy Recipients"
      },
      deleteConfirm: `Are you sure you want to delete subscription '{0}'?`
    },
    bulkEditRecipients: {
      title: "Bulk Edit Recipients",
      header: "Enter a comma delimited list of email addresses:",
      invalidEmails: "The following emails are invalid and will not be added:",
      cancel: "Cancel",
      submit: "Submit"
    },
    subscriptionFrequencyDropdown: {
      days: {
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
      },
      labels: {
        frequency: "Frequency",
        time: "Time",
        timeZone: "Time Zone"
      },
      dateResultDisplay: {
        every: `Every {0}`,
        at: `at {0}`,
        time: `{0} time`
      },
    },
    subscriptionStatusIndicator: {
      statuses: {
        paused: "PAUSED",
        pending: "PENDING",
        active: "ACTIVE",
        error: "ERROR"
      },
      buttons: {
        pause: "PAUSE",
        start: "START"
      },
      tooltips: {
        pauseSubs: "Pause Subscription",
        startSubs: "Start Subscription"
      }
    },
    validation: {
      name: {
        hasAName: "Subscription must have a name.",
        hasUniqueName: "Subscription must have an unique name."
      },
      templates: {
        hasOneTemplate: "Subscription must have at least one template."
      },
      recipients: {
        hasOneRecipient: "Subscription must have at least one recipient.",
        hasInvalidRecipients: "The recipient list has at least one user that has been deleted from HCSS Credentials or no longer has access to Pre-Construction. Please remove all the invalid users before saving."
      },
      time: {
        hasTime: "Subscription must have a time."
      },
      timeZone: {
        hasTimeZone: "Subscription must have a time zone."
      },
      day: {
        hasDay: "Subscription must have a day."
      }
    },
    notification: {
      subscription: "Subscription",
      saveFailed: "Failed to save subscription. Please try again.",
      deleteFailed: "Failed to delete subscription. Please try again.",
      getPreviewFailed: "Failed to load email previews of the subscription."
    },
    tooltip: {
      invalidUser: "Invalid User.",
      removedUser: "Removed User.",
      ownedByOtherUser: "This template is owned by other user."
    },
    modal: {
      delete: {
        title: "Delete subscription",
        deleteConfirm: `Are you sure you want to delete subscription '{0}'?`
      }
    }
  },
  featureStatus: {
    beta: "Beta",
  },
  sandbox: {
    enableSandboxButton: "Enable Sandbox",
  }
};